/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BulkDeleteFacilityServiceAreas200Response,
  BulkDeleteFacilityServiceAreasRequest,
  BulkImportFacilityServiceAreas200Response,
  BulkImportFacilityServiceAreasRequest,
  BulkUpdateBedRoomsRequest,
  BulkUpdateBedTypesRequest,
  BulkUpdateBedsRequest,
  BulkUpdateCriteriaCategoriesRequest,
  BulkUpdateCriteriaRequest,
  BulkUpdateFacilityServiceAreas200Response,
  BulkUpdateFacilityServiceAreasRequest,
  BulkUpdateScreenerBedUnitsRequest,
  BulkUpdateScreenerTagsRequest,
  CheckEligibility200Response,
  CombineDocuments200Response,
  CombineDocumentsRequest,
  CombineLeads200Response,
  CombineLeadsRequest,
  CopyLead201Response,
  CopyLeadRequest,
  CountActiveIntegrationEvents200Response,
  CreateCriteriaCategory201Response,
  CreateCriteriaTargets201Response,
  CreateCriteriaTargetsRequest,
  CreateDocumentExclusionTerm201Response,
  CreateDocumentExclusionTermRequest,
  CreateFacilityRegion201Response,
  CreateFacilityRegionRequest,
  CreateFacilityServiceArea201Response,
  CreateFacilityServiceAreaRequest,
  CreateFacilityServiceAreaUploadUrl200Response,
  CreateFilterView201Response,
  CreateFilterViewRequest,
  CreateGlobalCriteria201Response,
  CreateLeadAdditionalDocumentsRequest,
  CreateLeadInfo201Response,
  CreateLeadInfoRequest,
  CreateLeadWaitlistUpdate201Response,
  CreateLeadsBulkRequest,
  CreateMatrixCarePatient201Response,
  CreateMatrixCarePatientRequest,
  CreateOrganizationIPWhitelistRequest,
  CreateOrganizationIPWhitelistResponse,
  CreateOrganizationState201Response,
  CreateOrganizationStateTownsBulk201Response,
  CreateOrganizationStateTownsBulkRequest,
  CreateReferralRecipientConfig201Response,
  CreateReferralRecipientConfigRequest,
  CreateScreenerAdmissionFlag201Response,
  CreateScreenerLeadTag201Response,
  CreateSourceTag201Response,
  CreateSourceTagRequest,
  Criteria,
  CriteriaCategory,
  DeleteFacilityRegion200Response,
  DeleteOrganizationIPWhitelistResponse,
  DeleteReferralRecipientConfig200Response,
  ExchangeLeadRequest,
  ExchangeLeadResponse,
  ExecuteInstanceBulkDecision200Response,
  FacilityServiceAreaStatus,
  FilterViewScope,
  FindAllBedRooms200Response,
  FindAllBedTypes200Response,
  FindAllBeds200Response,
  FindAllCriteria200Response,
  FindAllCriteriaCategories200Response,
  FindAllCriteriaTargets200Response,
  FindAllExecutionsAvailableByFacilityId200Response,
  FindAllFacilityRegions200Response,
  FindAllFacilityServiceAreas200Response,
  FindAllFaxes200Response,
  FindAllFilterViews200Response,
  FindAllIcd10Codes200Response,
  FindAllIntegrationEventsByFacilityId200Response,
  FindAllOrganizationIPWhitelistResponse,
  FindAllOrganizationStates200Response,
  FindAllReferralRecipientConfigs200Response,
  FindAllScreenerAdmissionFlags200Response,
  FindAllScreenerAdmissionFlags200ResponseDataInner,
  FindAllScreenerBedUnits200Response,
  FindAllScreenerLeadWaitlist200Response,
  FindAllScreenerResidents200Response,
  FindAllScreenerTags200Response,
  FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner,
  FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist,
  FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner,
  FindAllSourceAllowNames200Response,
  FindAllSourceTags200Response,
  FindExchangeFacilitiesByFacilityBatch200Response,
  FindInstanceBulkDecisionCandidates200Response,
  FindOneBed200Response,
  FindOneMatrixCarePatientDetails200Response,
  GetAllowedRecipients200Response,
  GetAnalysisResultHistory200Response,
  GetDocumentExclusionTerms200Response,
  GetFacilityBedOccupancyStats200Response,
  GetFacilityInvoiceStatuses200Response,
  GetFacilityScreenerSettings200Response,
  GetLeadDiagnoses200Response,
  GetLeadShadowDecision200Response,
  GetLeadStageCounts200Response,
  GetOneFacilitySetting200Response,
  GetScreenerSetting200Response,
  GetUnreadFaxCount200Response,
  InstanceBulkDecisionRequest,
  InstanceBulkLostRequest,
  LinkFaxToReferralRequest,
  MatrixCarePatientDetails,
  OrganizationState,
  OrganizationStateTownSwitchTypeRequest,
  OrganizationStateType,
  OverrideAnalysisResult200Response,
  OverrideAnalysisResultRequest,
  PccE2eFixtureResetRequest,
  PdfDownloader200Response,
  ProcessIntegrationEvent500Response,
  RelocateScreenerResident200Response,
  RelocateScreenerResidentRequest,
  ResetPccE2eFixture200Response,
  ResetPccPushStatus200Response,
  ScheduledOccupancyType,
  SearchProviderDirectory200Response,
  SendLeadReferral201Response,
  SendLeadReferralRequest,
  SwapScreenerLeadResidents200Response,
  SwapScreenerLeadResidentsRequest,
  UpdateBedNoteRequest,
  UpdateDocumentExclusionTermRequest,
  UpdateFacilityRegionRequest,
  UpdateFacilityServiceAreaRequest,
  UpdateFaxReadStatusRequest,
  UpdateFilterViewRequest,
  UpdateLeadWaitlistRankRequest,
  UpdateLeadWaitlistStatus200Response,
  UpdateLeadWaitlistStatusRequest,
  UpdateReferralRecipientConfigRequest,
  UpdateReferralStatusRequest,
  UpdateScreenerBedUnitRankRequest,
  UpdateScreenerLeadAdmissionFlag200Response,
  UpdateScreenerLeadAdmissionFlagRequest,
  UpdateScreenerSettingRequest,
} from '../models/index';
import {
    BulkDeleteFacilityServiceAreas200ResponseFromJSON,
    BulkDeleteFacilityServiceAreas200ResponseToJSON,
    BulkDeleteFacilityServiceAreasRequestFromJSON,
    BulkDeleteFacilityServiceAreasRequestToJSON,
    BulkImportFacilityServiceAreas200ResponseFromJSON,
    BulkImportFacilityServiceAreas200ResponseToJSON,
    BulkImportFacilityServiceAreasRequestFromJSON,
    BulkImportFacilityServiceAreasRequestToJSON,
    BulkUpdateBedRoomsRequestFromJSON,
    BulkUpdateBedRoomsRequestToJSON,
    BulkUpdateBedTypesRequestFromJSON,
    BulkUpdateBedTypesRequestToJSON,
    BulkUpdateBedsRequestFromJSON,
    BulkUpdateBedsRequestToJSON,
    BulkUpdateCriteriaCategoriesRequestFromJSON,
    BulkUpdateCriteriaCategoriesRequestToJSON,
    BulkUpdateCriteriaRequestFromJSON,
    BulkUpdateCriteriaRequestToJSON,
    BulkUpdateFacilityServiceAreas200ResponseFromJSON,
    BulkUpdateFacilityServiceAreas200ResponseToJSON,
    BulkUpdateFacilityServiceAreasRequestFromJSON,
    BulkUpdateFacilityServiceAreasRequestToJSON,
    BulkUpdateScreenerBedUnitsRequestFromJSON,
    BulkUpdateScreenerBedUnitsRequestToJSON,
    BulkUpdateScreenerTagsRequestFromJSON,
    BulkUpdateScreenerTagsRequestToJSON,
    CheckEligibility200ResponseFromJSON,
    CheckEligibility200ResponseToJSON,
    CombineDocuments200ResponseFromJSON,
    CombineDocuments200ResponseToJSON,
    CombineDocumentsRequestFromJSON,
    CombineDocumentsRequestToJSON,
    CombineLeads200ResponseFromJSON,
    CombineLeads200ResponseToJSON,
    CombineLeadsRequestFromJSON,
    CombineLeadsRequestToJSON,
    CopyLead201ResponseFromJSON,
    CopyLead201ResponseToJSON,
    CopyLeadRequestFromJSON,
    CopyLeadRequestToJSON,
    CountActiveIntegrationEvents200ResponseFromJSON,
    CountActiveIntegrationEvents200ResponseToJSON,
    CreateCriteriaCategory201ResponseFromJSON,
    CreateCriteriaCategory201ResponseToJSON,
    CreateCriteriaTargets201ResponseFromJSON,
    CreateCriteriaTargets201ResponseToJSON,
    CreateCriteriaTargetsRequestFromJSON,
    CreateCriteriaTargetsRequestToJSON,
    CreateDocumentExclusionTerm201ResponseFromJSON,
    CreateDocumentExclusionTerm201ResponseToJSON,
    CreateDocumentExclusionTermRequestFromJSON,
    CreateDocumentExclusionTermRequestToJSON,
    CreateFacilityRegion201ResponseFromJSON,
    CreateFacilityRegion201ResponseToJSON,
    CreateFacilityRegionRequestFromJSON,
    CreateFacilityRegionRequestToJSON,
    CreateFacilityServiceArea201ResponseFromJSON,
    CreateFacilityServiceArea201ResponseToJSON,
    CreateFacilityServiceAreaRequestFromJSON,
    CreateFacilityServiceAreaRequestToJSON,
    CreateFacilityServiceAreaUploadUrl200ResponseFromJSON,
    CreateFacilityServiceAreaUploadUrl200ResponseToJSON,
    CreateFilterView201ResponseFromJSON,
    CreateFilterView201ResponseToJSON,
    CreateFilterViewRequestFromJSON,
    CreateFilterViewRequestToJSON,
    CreateGlobalCriteria201ResponseFromJSON,
    CreateGlobalCriteria201ResponseToJSON,
    CreateLeadAdditionalDocumentsRequestFromJSON,
    CreateLeadAdditionalDocumentsRequestToJSON,
    CreateLeadInfo201ResponseFromJSON,
    CreateLeadInfo201ResponseToJSON,
    CreateLeadInfoRequestFromJSON,
    CreateLeadInfoRequestToJSON,
    CreateLeadWaitlistUpdate201ResponseFromJSON,
    CreateLeadWaitlistUpdate201ResponseToJSON,
    CreateLeadsBulkRequestFromJSON,
    CreateLeadsBulkRequestToJSON,
    CreateMatrixCarePatient201ResponseFromJSON,
    CreateMatrixCarePatient201ResponseToJSON,
    CreateMatrixCarePatientRequestFromJSON,
    CreateMatrixCarePatientRequestToJSON,
    CreateOrganizationIPWhitelistRequestFromJSON,
    CreateOrganizationIPWhitelistRequestToJSON,
    CreateOrganizationIPWhitelistResponseFromJSON,
    CreateOrganizationIPWhitelistResponseToJSON,
    CreateOrganizationState201ResponseFromJSON,
    CreateOrganizationState201ResponseToJSON,
    CreateOrganizationStateTownsBulk201ResponseFromJSON,
    CreateOrganizationStateTownsBulk201ResponseToJSON,
    CreateOrganizationStateTownsBulkRequestFromJSON,
    CreateOrganizationStateTownsBulkRequestToJSON,
    CreateReferralRecipientConfig201ResponseFromJSON,
    CreateReferralRecipientConfig201ResponseToJSON,
    CreateReferralRecipientConfigRequestFromJSON,
    CreateReferralRecipientConfigRequestToJSON,
    CreateScreenerAdmissionFlag201ResponseFromJSON,
    CreateScreenerAdmissionFlag201ResponseToJSON,
    CreateScreenerLeadTag201ResponseFromJSON,
    CreateScreenerLeadTag201ResponseToJSON,
    CreateSourceTag201ResponseFromJSON,
    CreateSourceTag201ResponseToJSON,
    CreateSourceTagRequestFromJSON,
    CreateSourceTagRequestToJSON,
    CriteriaFromJSON,
    CriteriaToJSON,
    CriteriaCategoryFromJSON,
    CriteriaCategoryToJSON,
    DeleteFacilityRegion200ResponseFromJSON,
    DeleteFacilityRegion200ResponseToJSON,
    DeleteOrganizationIPWhitelistResponseFromJSON,
    DeleteOrganizationIPWhitelistResponseToJSON,
    DeleteReferralRecipientConfig200ResponseFromJSON,
    DeleteReferralRecipientConfig200ResponseToJSON,
    ExchangeLeadRequestFromJSON,
    ExchangeLeadRequestToJSON,
    ExchangeLeadResponseFromJSON,
    ExchangeLeadResponseToJSON,
    ExecuteInstanceBulkDecision200ResponseFromJSON,
    ExecuteInstanceBulkDecision200ResponseToJSON,
    FacilityServiceAreaStatusFromJSON,
    FacilityServiceAreaStatusToJSON,
    FilterViewScopeFromJSON,
    FilterViewScopeToJSON,
    FindAllBedRooms200ResponseFromJSON,
    FindAllBedRooms200ResponseToJSON,
    FindAllBedTypes200ResponseFromJSON,
    FindAllBedTypes200ResponseToJSON,
    FindAllBeds200ResponseFromJSON,
    FindAllBeds200ResponseToJSON,
    FindAllCriteria200ResponseFromJSON,
    FindAllCriteria200ResponseToJSON,
    FindAllCriteriaCategories200ResponseFromJSON,
    FindAllCriteriaCategories200ResponseToJSON,
    FindAllCriteriaTargets200ResponseFromJSON,
    FindAllCriteriaTargets200ResponseToJSON,
    FindAllExecutionsAvailableByFacilityId200ResponseFromJSON,
    FindAllExecutionsAvailableByFacilityId200ResponseToJSON,
    FindAllFacilityRegions200ResponseFromJSON,
    FindAllFacilityRegions200ResponseToJSON,
    FindAllFacilityServiceAreas200ResponseFromJSON,
    FindAllFacilityServiceAreas200ResponseToJSON,
    FindAllFaxes200ResponseFromJSON,
    FindAllFaxes200ResponseToJSON,
    FindAllFilterViews200ResponseFromJSON,
    FindAllFilterViews200ResponseToJSON,
    FindAllIcd10Codes200ResponseFromJSON,
    FindAllIcd10Codes200ResponseToJSON,
    FindAllIntegrationEventsByFacilityId200ResponseFromJSON,
    FindAllIntegrationEventsByFacilityId200ResponseToJSON,
    FindAllOrganizationIPWhitelistResponseFromJSON,
    FindAllOrganizationIPWhitelistResponseToJSON,
    FindAllOrganizationStates200ResponseFromJSON,
    FindAllOrganizationStates200ResponseToJSON,
    FindAllReferralRecipientConfigs200ResponseFromJSON,
    FindAllReferralRecipientConfigs200ResponseToJSON,
    FindAllScreenerAdmissionFlags200ResponseFromJSON,
    FindAllScreenerAdmissionFlags200ResponseToJSON,
    FindAllScreenerAdmissionFlags200ResponseDataInnerFromJSON,
    FindAllScreenerAdmissionFlags200ResponseDataInnerToJSON,
    FindAllScreenerBedUnits200ResponseFromJSON,
    FindAllScreenerBedUnits200ResponseToJSON,
    FindAllScreenerLeadWaitlist200ResponseFromJSON,
    FindAllScreenerLeadWaitlist200ResponseToJSON,
    FindAllScreenerResidents200ResponseFromJSON,
    FindAllScreenerResidents200ResponseToJSON,
    FindAllScreenerTags200ResponseFromJSON,
    FindAllScreenerTags200ResponseToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInnerFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInnerToJSON,
    FindAllSourceAllowNames200ResponseFromJSON,
    FindAllSourceAllowNames200ResponseToJSON,
    FindAllSourceTags200ResponseFromJSON,
    FindAllSourceTags200ResponseToJSON,
    FindExchangeFacilitiesByFacilityBatch200ResponseFromJSON,
    FindExchangeFacilitiesByFacilityBatch200ResponseToJSON,
    FindInstanceBulkDecisionCandidates200ResponseFromJSON,
    FindInstanceBulkDecisionCandidates200ResponseToJSON,
    FindOneBed200ResponseFromJSON,
    FindOneBed200ResponseToJSON,
    FindOneMatrixCarePatientDetails200ResponseFromJSON,
    FindOneMatrixCarePatientDetails200ResponseToJSON,
    GetAllowedRecipients200ResponseFromJSON,
    GetAllowedRecipients200ResponseToJSON,
    GetAnalysisResultHistory200ResponseFromJSON,
    GetAnalysisResultHistory200ResponseToJSON,
    GetDocumentExclusionTerms200ResponseFromJSON,
    GetDocumentExclusionTerms200ResponseToJSON,
    GetFacilityBedOccupancyStats200ResponseFromJSON,
    GetFacilityBedOccupancyStats200ResponseToJSON,
    GetFacilityInvoiceStatuses200ResponseFromJSON,
    GetFacilityInvoiceStatuses200ResponseToJSON,
    GetFacilityScreenerSettings200ResponseFromJSON,
    GetFacilityScreenerSettings200ResponseToJSON,
    GetLeadDiagnoses200ResponseFromJSON,
    GetLeadDiagnoses200ResponseToJSON,
    GetLeadShadowDecision200ResponseFromJSON,
    GetLeadShadowDecision200ResponseToJSON,
    GetLeadStageCounts200ResponseFromJSON,
    GetLeadStageCounts200ResponseToJSON,
    GetOneFacilitySetting200ResponseFromJSON,
    GetOneFacilitySetting200ResponseToJSON,
    GetScreenerSetting200ResponseFromJSON,
    GetScreenerSetting200ResponseToJSON,
    GetUnreadFaxCount200ResponseFromJSON,
    GetUnreadFaxCount200ResponseToJSON,
    InstanceBulkDecisionRequestFromJSON,
    InstanceBulkDecisionRequestToJSON,
    InstanceBulkLostRequestFromJSON,
    InstanceBulkLostRequestToJSON,
    LinkFaxToReferralRequestFromJSON,
    LinkFaxToReferralRequestToJSON,
    MatrixCarePatientDetailsFromJSON,
    MatrixCarePatientDetailsToJSON,
    OrganizationStateFromJSON,
    OrganizationStateToJSON,
    OrganizationStateTownSwitchTypeRequestFromJSON,
    OrganizationStateTownSwitchTypeRequestToJSON,
    OrganizationStateTypeFromJSON,
    OrganizationStateTypeToJSON,
    OverrideAnalysisResult200ResponseFromJSON,
    OverrideAnalysisResult200ResponseToJSON,
    OverrideAnalysisResultRequestFromJSON,
    OverrideAnalysisResultRequestToJSON,
    PccE2eFixtureResetRequestFromJSON,
    PccE2eFixtureResetRequestToJSON,
    PdfDownloader200ResponseFromJSON,
    PdfDownloader200ResponseToJSON,
    ProcessIntegrationEvent500ResponseFromJSON,
    ProcessIntegrationEvent500ResponseToJSON,
    RelocateScreenerResident200ResponseFromJSON,
    RelocateScreenerResident200ResponseToJSON,
    RelocateScreenerResidentRequestFromJSON,
    RelocateScreenerResidentRequestToJSON,
    ResetPccE2eFixture200ResponseFromJSON,
    ResetPccE2eFixture200ResponseToJSON,
    ResetPccPushStatus200ResponseFromJSON,
    ResetPccPushStatus200ResponseToJSON,
    ScheduledOccupancyTypeFromJSON,
    ScheduledOccupancyTypeToJSON,
    SearchProviderDirectory200ResponseFromJSON,
    SearchProviderDirectory200ResponseToJSON,
    SendLeadReferral201ResponseFromJSON,
    SendLeadReferral201ResponseToJSON,
    SendLeadReferralRequestFromJSON,
    SendLeadReferralRequestToJSON,
    SwapScreenerLeadResidents200ResponseFromJSON,
    SwapScreenerLeadResidents200ResponseToJSON,
    SwapScreenerLeadResidentsRequestFromJSON,
    SwapScreenerLeadResidentsRequestToJSON,
    UpdateBedNoteRequestFromJSON,
    UpdateBedNoteRequestToJSON,
    UpdateDocumentExclusionTermRequestFromJSON,
    UpdateDocumentExclusionTermRequestToJSON,
    UpdateFacilityRegionRequestFromJSON,
    UpdateFacilityRegionRequestToJSON,
    UpdateFacilityServiceAreaRequestFromJSON,
    UpdateFacilityServiceAreaRequestToJSON,
    UpdateFaxReadStatusRequestFromJSON,
    UpdateFaxReadStatusRequestToJSON,
    UpdateFilterViewRequestFromJSON,
    UpdateFilterViewRequestToJSON,
    UpdateLeadWaitlistRankRequestFromJSON,
    UpdateLeadWaitlistRankRequestToJSON,
    UpdateLeadWaitlistStatus200ResponseFromJSON,
    UpdateLeadWaitlistStatus200ResponseToJSON,
    UpdateLeadWaitlistStatusRequestFromJSON,
    UpdateLeadWaitlistStatusRequestToJSON,
    UpdateReferralRecipientConfigRequestFromJSON,
    UpdateReferralRecipientConfigRequestToJSON,
    UpdateReferralStatusRequestFromJSON,
    UpdateReferralStatusRequestToJSON,
    UpdateScreenerBedUnitRankRequestFromJSON,
    UpdateScreenerBedUnitRankRequestToJSON,
    UpdateScreenerLeadAdmissionFlag200ResponseFromJSON,
    UpdateScreenerLeadAdmissionFlag200ResponseToJSON,
    UpdateScreenerLeadAdmissionFlagRequestFromJSON,
    UpdateScreenerLeadAdmissionFlagRequestToJSON,
    UpdateScreenerSettingRequestFromJSON,
    UpdateScreenerSettingRequestToJSON,
} from '../models/index';

export interface BulkDeleteFacilityServiceAreasOperationRequest {
    facilityId: string;
    bulkDeleteFacilityServiceAreasRequest: BulkDeleteFacilityServiceAreasRequest;
}

export interface BulkImportFacilityServiceAreasOperationRequest {
    facilityId: string;
    bulkImportFacilityServiceAreasRequest: BulkImportFacilityServiceAreasRequest;
}

export interface BulkUpdateBedRoomsOperationRequest {
    facilityId: string;
    unitId: string;
    bulkUpdateBedRoomsRequest: BulkUpdateBedRoomsRequest;
}

export interface BulkUpdateBedTypesOperationRequest {
    facilityId: string;
    bulkUpdateBedTypesRequest: BulkUpdateBedTypesRequest;
}

export interface BulkUpdateBedsOperationRequest {
    roomId: string;
    facilityId: string;
    bulkUpdateBedsRequest: BulkUpdateBedsRequest;
}

export interface BulkUpdateCriteriaOperationRequest {
    criteriaId: string;
    bulkUpdateCriteriaRequest: BulkUpdateCriteriaRequest;
}

export interface BulkUpdateFacilityServiceAreasOperationRequest {
    facilityId: string;
    bulkUpdateFacilityServiceAreasRequest: BulkUpdateFacilityServiceAreasRequest;
}

export interface BulkUpdateScreenerBedUnitsOperationRequest {
    facilityId: string;
    bulkUpdateScreenerBedUnitsRequest: BulkUpdateScreenerBedUnitsRequest;
}

export interface BulkUpdateScreenerTagsOperationRequest {
    bulkUpdateScreenerTagsRequest: BulkUpdateScreenerTagsRequest;
}

export interface CheckEligibilityRequest {
    leadId: string;
    action: CheckEligibilityActionEnum;
    date?: Date;
}

export interface CombineDocumentsOperationRequest {
    combineDocumentsRequest: CombineDocumentsRequest;
}

export interface CombineLeadsOperationRequest {
    combineLeadsRequest: CombineLeadsRequest;
}

export interface CopyLeadOperationRequest {
    leadId: string;
    copyLeadRequest: CopyLeadRequest;
}

export interface CountActiveIntegrationEventsRequest {
    facilityId: string;
}

export interface CreateCriteriaRequest {
    criteria: Criteria;
}

export interface CreateCriteriaCategoryRequest {
    criteriaCategory: CriteriaCategory;
}

export interface CreateCriteriaTargetsOperationRequest {
    createCriteriaTargetsRequest: CreateCriteriaTargetsRequest;
}

export interface CreateDocumentExclusionTermOperationRequest {
    createDocumentExclusionTermRequest: CreateDocumentExclusionTermRequest;
}

export interface CreateFacilityRegionOperationRequest {
    createFacilityRegionRequest: CreateFacilityRegionRequest;
}

export interface CreateFacilityServiceAreaOperationRequest {
    facilityId: string;
    createFacilityServiceAreaRequest: CreateFacilityServiceAreaRequest;
}

export interface CreateFacilityServiceAreaUploadUrlRequest {
    facilityId: string;
}

export interface CreateFaxReferralRequest {
    id: string;
}

export interface CreateFilterViewOperationRequest {
    createFilterViewRequest: CreateFilterViewRequest;
}

export interface CreateGlobalCriteriaRequest {
    criteria: Criteria;
}

export interface CreateLeadAdditionalDocumentsOperationRequest {
    leadId: string;
    createLeadAdditionalDocumentsRequest: CreateLeadAdditionalDocumentsRequest;
}

export interface CreateLeadInfoOperationRequest {
    createLeadInfoRequest: CreateLeadInfoRequest;
}

export interface CreateLeadWaitlistRequest {
    leadId: string;
}

export interface CreateLeadWaitlistUpdateRequest {
    waitlistId: string;
    findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner;
}

export interface CreateLeadsBulkOperationRequest {
    createLeadsBulkRequest: CreateLeadsBulkRequest;
}

export interface CreateMatrixCarePatientOperationRequest {
    leadId: string;
    createMatrixCarePatientRequest: CreateMatrixCarePatientRequest;
}

export interface CreateMatrixCarePatientDetailsRequest {
    leadId: string;
    matrixCarePatientDetails: MatrixCarePatientDetails;
}

export interface CreateOrganizationIPWhitelistOperationRequest {
    createOrganizationIPWhitelistRequest: CreateOrganizationIPWhitelistRequest;
}

export interface CreateOrganizationStateRequest {
    organizationState: OrganizationState;
}

export interface CreateOrganizationStateTownsBulkOperationRequest {
    createOrganizationStateTownsBulkRequest: CreateOrganizationStateTownsBulkRequest;
}

export interface CreateReferralRecipientConfigOperationRequest {
    createReferralRecipientConfigRequest: CreateReferralRecipientConfigRequest;
}

export interface CreateScreenerAdmissionFlagRequest {
    findAllScreenerAdmissionFlags200ResponseDataInner: FindAllScreenerAdmissionFlags200ResponseDataInner;
}

export interface CreateScreenerLeadTagRequest {
    findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner;
}

export interface CreateSourceTagOperationRequest {
    createSourceTagRequest: CreateSourceTagRequest;
}

export interface DeleteAdditionalDocumentForLeadRequest {
    leadId: string;
    documentId: string;
}

export interface DeleteCriteriaRequest {
    criteriaId: string;
}

export interface DeleteCriteriaCategoryRequest {
    categoryId: string;
}

export interface DeleteCriteriaTargetsRequest {
    criteriaId: string;
}

export interface DeleteDocumentExclusionTermRequest {
    termId: string;
}

export interface DeleteFacilityRegionRequest {
    id: string;
}

export interface DeleteFacilityServiceAreaRequest {
    facilityId: string;
    id: string;
}

export interface DeleteFilterViewByIdRequest {
    id: string;
}

export interface DeleteOrganizationIPWhitelistRequest {
    ipAddress: string;
}

export interface DeleteOrganizationStateByIdRequest {
    id: string;
}

export interface DeleteOrganizationStateTownByIdRequest {
    id: string;
}

export interface DeleteReferralRecipientConfigRequest {
    id: number;
}

export interface DeleteScreenerAdmissionFlagByIdRequest {
    id: string;
}

export interface DeleteScreenerLeadTagRequest {
    id: string;
}

export interface DeleteScreenerTagByIdRequest {
    id: string;
}

export interface ExchangeLeadOperationRequest {
    leadId: string;
    exchangeLeadRequest: ExchangeLeadRequest;
}

export interface ExecuteInstanceBulkDecisionRequest {
    leadId: string;
    instanceBulkDecisionRequest: InstanceBulkDecisionRequest;
}

export interface ExecuteInstanceBulkLostRequest {
    leadId: string;
    instanceBulkLostRequest: InstanceBulkLostRequest;
}

export interface FindAllBedRoomsRequest {
    unitId: string;
}

export interface FindAllBedTypesRequest {
    facilityId: string;
}

export interface FindAllBedsRequest {
    facilityId: string;
    bedTypeIds?: string;
    includeOccupied?: boolean;
    availabilityFrom?: string;
    availabilityTo?: string;
    roomId?: string;
}

export interface FindAllCriteriaRequest {
    facilityId: string;
    isInformational: boolean;
}

export interface FindAllCriteriaCategoriesRequest {
    facilityId?: string;
}

export interface FindAllCriteriaTargetsRequest {
    search?: string;
    criteriaType?: FindAllCriteriaTargetsCriteriaTypeEnum;
    categoryId?: string;
    qualifier?: string;
    appliesToFacilityId?: string;
}

export interface FindAllExecutionsAvailableByFacilityIdRequest {
    facilityIds: string;
}

export interface FindAllFacilityServiceAreasRequest {
    facilityId: string;
    page?: number;
    limit?: number;
    search?: string;
    status?: FacilityServiceAreaStatus;
}

export interface FindAllFaxesRequest {
    facilityId?: string;
    facilityType?: FindAllFaxesFacilityTypeEnum;
    limit?: number;
    page?: number;
}

export interface FindAllFilterViewsRequest {
    scope: FilterViewScope;
    viewKey: string;
}

export interface FindAllIcd10CodesRequest {
    search?: string;
    limit?: number;
    page?: number;
}

export interface FindAllIntegrationEventsByFacilityIdRequest {
    facilityId: string;
    page?: number;
    limit?: number;
    filter?: FindAllIntegrationEventsByFacilityIdFilterEnum;
    search?: string;
}

export interface FindAllOrganizationStatesRequest {
    type: OrganizationStateType;
}

export interface FindAllReferralRecipientConfigsRequest {
    senderFacilityId?: number;
}

export interface FindAllScheduledScreenerResidentsRequest {
    facilityId: string;
    scheduledOccupancyType: ScheduledOccupancyType;
    limit?: number;
    page?: number;
    startDate?: Date;
    endDate?: Date;
    search?: string;
    sourceId?: string;
    connector?: string;
    bedTypeId?: string;
    includeCancelled?: boolean;
}

export interface FindAllScreenerBedUnitsRequest {
    facilityId: string;
}

export interface FindAllScreenerLeadWaitlistRequest {
    facilityId: string;
    status?: string;
    limit?: number;
    page?: number;
    search?: string;
    sourceId?: string;
    admissionStatus?: string;
    statusId?: string;
    includeEmptyAdmission?: boolean;
}

export interface FindAllScreenerResidentsRequest {
    facilityId: string;
    limit?: number;
    page?: number;
    search?: string;
    sourceId?: string;
    bedTypeId?: string;
    onlyTodayActivity?: boolean;
    stayType?: string;
    payerType?: string;
    payer?: string;
    payerSource?: string;
    includeNullPayerType?: boolean;
    includeNullPayerSource?: boolean;
    admissionStatus?: string;
}

export interface FindAllScreenerTagsRequest {
    facilityId: string;
}

export interface FindAllSourceAllowNamesRequest {
    facilityId: string;
    page?: number;
    limit?: number;
    search?: string;
}

export interface FindExchangeFacilitiesByFacilityBatchRequest {
    facilityIds: string;
}

export interface FindInstanceBulkDecisionCandidatesRequest {
    leadId: string;
}

export interface FindInstanceBulkLostCandidatesRequest {
    leadId: string;
}

export interface FindOneBedRequest {
    bedId: string;
}

export interface FindOneMatrixCarePatientDetailsRequest {
    leadId: string;
}

export interface GetAllowedRecipientsRequest {
    senderFacilityId: number;
    referralType?: GetAllowedRecipientsReferralTypeEnum;
}

export interface GetAnalysisResultHistoryRequest {
    leadId: string;
    resultId: string;
}

export interface GetDocumentExclusionTermsRequest {
    facilityId: string;
}

export interface GetFacilityBedOccupancyStatsRequest {
    facilityId: string;
}

export interface GetFacilityInvoiceStatusesRequest {
    facilityId: string;
}

export interface GetFacilityScreenerSettingsRequest {
    facilityIds: string;
}

export interface GetLeadDiagnosesRequest {
    leadId: string;
}

export interface GetLeadShadowDecisionRequest {
    leadId: string;
}

export interface GetLeadStageCountsRequest {
    facilityId?: string;
    sourceId?: string;
    search?: string;
    suggestion?: string;
    connector?: string;
    payerType?: string;
    payer?: string;
    payerSource?: string;
    includeNullPayerType?: boolean;
    includeNullPayerSource?: boolean;
    pccStatus?: string;
    matrixCareStatus?: string;
    hasNewHospitalMessages?: boolean;
    hasNewDocuments?: boolean;
    assigneeUserIds?: string;
    unassigned?: boolean;
}

export interface GetOneFacilitySettingRequest {
    facilityId: string;
    settingName: string;
}

export interface GetScreenerSettingRequest {
    settingName: string;
}

export interface GetUnreadFaxCountRequest {
    facilityId?: string;
    facilityType?: GetUnreadFaxCountFacilityTypeEnum;
}

export interface LinkFaxToReferralOperationRequest {
    id: string;
    linkFaxToReferralRequest: LinkFaxToReferralRequest;
}

export interface OverrideAnalysisResultOperationRequest {
    leadId: string;
    resultId: string;
    overrideAnalysisResultRequest: OverrideAnalysisResultRequest;
}

export interface PdfDownloaderRequest {
    documentIds: string;
    leadId: string;
}

export interface ProcessIntegrationEventRequest {
    integrationEventId: string;
    action: ProcessIntegrationEventActionEnum;
}

export interface RelocateScreenerResidentOperationRequest {
    residentId: string;
    relocateScreenerResidentRequest: RelocateScreenerResidentRequest;
}

export interface ResetPccE2eFixtureRequest {
    leadId: string;
    pccE2eFixtureResetRequest: PccE2eFixtureResetRequest;
}

export interface ResetPccPushStatusRequest {
    leadId: string;
}

export interface RevertAnalysisResultRequest {
    leadId: string;
    resultId: string;
}

export interface SearchProviderDirectoryRequest {
    q: string;
    facilityId: string;
    providerType?: string;
    state?: string;
    zip?: string;
    limit?: number;
    page?: number;
}

export interface SendLeadReferralOperationRequest {
    leadId: string;
    sendLeadReferralRequest: SendLeadReferralRequest;
}

export interface SwapScreenerLeadResidentsOperationRequest {
    swapScreenerLeadResidentsRequest: SwapScreenerLeadResidentsRequest;
}

export interface SwitchOrganizationStateTownTypeRequest {
    id: string;
    organizationStateTownSwitchTypeRequest: OrganizationStateTownSwitchTypeRequest;
}

export interface TriggerPdpmEstimatorRequest {
    leadId: string;
}

export interface UpdateBedNoteOperationRequest {
    bedId: string;
    updateBedNoteRequest: UpdateBedNoteRequest;
}

export interface UpdateCriteriaRequest {
    criteriaId: string;
    criteria: Criteria;
}

export interface UpdateCriteriaCategoriesRequest {
    bulkUpdateCriteriaCategoriesRequest: BulkUpdateCriteriaCategoriesRequest;
}

export interface UpdateCriteriaTargetsRequest {
    criteriaId: string;
    createCriteriaTargetsRequest: CreateCriteriaTargetsRequest;
}

export interface UpdateDocumentExclusionTermOperationRequest {
    termId: string;
    updateDocumentExclusionTermRequest: UpdateDocumentExclusionTermRequest;
}

export interface UpdateFacilityRegionOperationRequest {
    id: string;
    updateFacilityRegionRequest: UpdateFacilityRegionRequest;
}

export interface UpdateFacilityServiceAreaOperationRequest {
    facilityId: string;
    id: string;
    updateFacilityServiceAreaRequest: UpdateFacilityServiceAreaRequest;
}

export interface UpdateFacilitySettingRequest {
    facilityId: string;
    settingName: string;
    updateScreenerSettingRequest: UpdateScreenerSettingRequest;
}

export interface UpdateFaxReadStatusOperationRequest {
    id: string;
    updateFaxReadStatusRequest: UpdateFaxReadStatusRequest;
}

export interface UpdateFilterViewByIdRequest {
    id: string;
    updateFilterViewRequest: UpdateFilterViewRequest;
}

export interface UpdateLeadInfoRequest {
    leadId: string;
    createLeadInfoRequest: CreateLeadInfoRequest;
}

export interface UpdateLeadWaitlistRequest {
    waitlistId: string;
    findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist;
}

export interface UpdateLeadWaitlistRankOperationRequest {
    waitlistId: string;
    updateLeadWaitlistRankRequest: UpdateLeadWaitlistRankRequest;
}

export interface UpdateLeadWaitlistStatusOperationRequest {
    waitlistId: string;
    updateLeadWaitlistStatusRequest: UpdateLeadWaitlistStatusRequest;
}

export interface UpdateReferralRecipientConfigOperationRequest {
    id: number;
    updateReferralRecipientConfigRequest: UpdateReferralRecipientConfigRequest;
}

export interface UpdateReferralStatusOperationRequest {
    referralId: string;
    updateReferralStatusRequest: UpdateReferralStatusRequest;
}

export interface UpdateScreenerAdmissionFlagRequest {
    id: string;
    findAllScreenerAdmissionFlags200ResponseDataInner: FindAllScreenerAdmissionFlags200ResponseDataInner;
}

export interface UpdateScreenerBedUnitRankOperationRequest {
    bedUnitId: string;
    updateScreenerBedUnitRankRequest: UpdateScreenerBedUnitRankRequest;
}

export interface UpdateScreenerLeadAdmissionFlagOperationRequest {
    id: string;
    updateScreenerLeadAdmissionFlagRequest: UpdateScreenerLeadAdmissionFlagRequest;
}

export interface UpdateScreenerSettingOperationRequest {
    settingName: string;
    updateScreenerSettingRequest: UpdateScreenerSettingRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Delete multiple facility service-area rows by id
     */
    async bulkDeleteFacilityServiceAreasRaw(requestParameters: BulkDeleteFacilityServiceAreasOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkDeleteFacilityServiceAreas200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling bulkDeleteFacilityServiceAreas.');
        }

        if (requestParameters.bulkDeleteFacilityServiceAreasRequest === null || requestParameters.bulkDeleteFacilityServiceAreasRequest === undefined) {
            throw new runtime.RequiredError('bulkDeleteFacilityServiceAreasRequest','Required parameter requestParameters.bulkDeleteFacilityServiceAreasRequest was null or undefined when calling bulkDeleteFacilityServiceAreas.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/facilities/{facility_id}/service-areas/bulk`.replace(`{${"facility_id"}}`, encodeURIComponent(String(requestParameters.facilityId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: BulkDeleteFacilityServiceAreasRequestToJSON(requestParameters.bulkDeleteFacilityServiceAreasRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkDeleteFacilityServiceAreas200ResponseFromJSON(jsonValue));
    }

    /**
     * Delete multiple facility service-area rows by id
     */
    async bulkDeleteFacilityServiceAreas(requestParameters: BulkDeleteFacilityServiceAreasOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkDeleteFacilityServiceAreas200Response> {
        const response = await this.bulkDeleteFacilityServiceAreasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reads the CSV identified by `s3_key`, validates each row, and upserts valid rows by `(facility_id, zip)`. Returns per-row errors for any rows that failed validation. 
     * Bulk-import facility service areas from a previously-uploaded CSV
     */
    async bulkImportFacilityServiceAreasRaw(requestParameters: BulkImportFacilityServiceAreasOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkImportFacilityServiceAreas200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling bulkImportFacilityServiceAreas.');
        }

        if (requestParameters.bulkImportFacilityServiceAreasRequest === null || requestParameters.bulkImportFacilityServiceAreasRequest === undefined) {
            throw new runtime.RequiredError('bulkImportFacilityServiceAreasRequest','Required parameter requestParameters.bulkImportFacilityServiceAreasRequest was null or undefined when calling bulkImportFacilityServiceAreas.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/facilities/{facility_id}/service-areas/bulk`.replace(`{${"facility_id"}}`, encodeURIComponent(String(requestParameters.facilityId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkImportFacilityServiceAreasRequestToJSON(requestParameters.bulkImportFacilityServiceAreasRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkImportFacilityServiceAreas200ResponseFromJSON(jsonValue));
    }

    /**
     * Reads the CSV identified by `s3_key`, validates each row, and upserts valid rows by `(facility_id, zip)`. Returns per-row errors for any rows that failed validation. 
     * Bulk-import facility service areas from a previously-uploaded CSV
     */
    async bulkImportFacilityServiceAreas(requestParameters: BulkImportFacilityServiceAreasOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkImportFacilityServiceAreas200Response> {
        const response = await this.bulkImportFacilityServiceAreasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update bed rooms
     * Update bed rooms
     */
    async bulkUpdateBedRoomsRaw(requestParameters: BulkUpdateBedRoomsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllBedRooms200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling bulkUpdateBedRooms.');
        }

        if (requestParameters.unitId === null || requestParameters.unitId === undefined) {
            throw new runtime.RequiredError('unitId','Required parameter requestParameters.unitId was null or undefined when calling bulkUpdateBedRooms.');
        }

        if (requestParameters.bulkUpdateBedRoomsRequest === null || requestParameters.bulkUpdateBedRoomsRequest === undefined) {
            throw new runtime.RequiredError('bulkUpdateBedRoomsRequest','Required parameter requestParameters.bulkUpdateBedRoomsRequest was null or undefined when calling bulkUpdateBedRooms.');
        }

        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        if (requestParameters.unitId !== undefined) {
            queryParameters['unit_id'] = requestParameters.unitId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/bed-rooms`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateBedRoomsRequestToJSON(requestParameters.bulkUpdateBedRoomsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllBedRooms200ResponseFromJSON(jsonValue));
    }

    /**
     * Update bed rooms
     * Update bed rooms
     */
    async bulkUpdateBedRooms(requestParameters: BulkUpdateBedRoomsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllBedRooms200Response> {
        const response = await this.bulkUpdateBedRoomsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update bed types
     * Update bed types
     */
    async bulkUpdateBedTypesRaw(requestParameters: BulkUpdateBedTypesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllBedTypes200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling bulkUpdateBedTypes.');
        }

        if (requestParameters.bulkUpdateBedTypesRequest === null || requestParameters.bulkUpdateBedTypesRequest === undefined) {
            throw new runtime.RequiredError('bulkUpdateBedTypesRequest','Required parameter requestParameters.bulkUpdateBedTypesRequest was null or undefined when calling bulkUpdateBedTypes.');
        }

        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/bed-types`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateBedTypesRequestToJSON(requestParameters.bulkUpdateBedTypesRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllBedTypes200ResponseFromJSON(jsonValue));
    }

    /**
     * Update bed types
     * Update bed types
     */
    async bulkUpdateBedTypes(requestParameters: BulkUpdateBedTypesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllBedTypes200Response> {
        const response = await this.bulkUpdateBedTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update beds in a room
     * Bulk update beds in a room
     */
    async bulkUpdateBedsRaw(requestParameters: BulkUpdateBedsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllBeds200Response>> {
        if (requestParameters.roomId === null || requestParameters.roomId === undefined) {
            throw new runtime.RequiredError('roomId','Required parameter requestParameters.roomId was null or undefined when calling bulkUpdateBeds.');
        }

        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling bulkUpdateBeds.');
        }

        if (requestParameters.bulkUpdateBedsRequest === null || requestParameters.bulkUpdateBedsRequest === undefined) {
            throw new runtime.RequiredError('bulkUpdateBedsRequest','Required parameter requestParameters.bulkUpdateBedsRequest was null or undefined when calling bulkUpdateBeds.');
        }

        const queryParameters: any = {};

        if (requestParameters.roomId !== undefined) {
            queryParameters['room_id'] = requestParameters.roomId;
        }

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/beds`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateBedsRequestToJSON(requestParameters.bulkUpdateBedsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllBeds200ResponseFromJSON(jsonValue));
    }

    /**
     * Update beds in a room
     * Bulk update beds in a room
     */
    async bulkUpdateBeds(requestParameters: BulkUpdateBedsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllBeds200Response> {
        const response = await this.bulkUpdateBedsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Bulk update screener criteria
     */
    async bulkUpdateCriteriaRaw(requestParameters: BulkUpdateCriteriaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.criteriaId === null || requestParameters.criteriaId === undefined) {
            throw new runtime.RequiredError('criteriaId','Required parameter requestParameters.criteriaId was null or undefined when calling bulkUpdateCriteria.');
        }

        if (requestParameters.bulkUpdateCriteriaRequest === null || requestParameters.bulkUpdateCriteriaRequest === undefined) {
            throw new runtime.RequiredError('bulkUpdateCriteriaRequest','Required parameter requestParameters.bulkUpdateCriteriaRequest was null or undefined when calling bulkUpdateCriteria.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/criteria/{criteria_id}/rank`.replace(`{${"criteria_id"}}`, encodeURIComponent(String(requestParameters.criteriaId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateCriteriaRequestToJSON(requestParameters.bulkUpdateCriteriaRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Bulk update screener criteria
     */
    async bulkUpdateCriteria(requestParameters: BulkUpdateCriteriaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.bulkUpdateCriteriaRaw(requestParameters, initOverrides);
    }

    /**
     * Apply the same status and/or notes change to multiple rows
     */
    async bulkUpdateFacilityServiceAreasRaw(requestParameters: BulkUpdateFacilityServiceAreasOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkUpdateFacilityServiceAreas200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling bulkUpdateFacilityServiceAreas.');
        }

        if (requestParameters.bulkUpdateFacilityServiceAreasRequest === null || requestParameters.bulkUpdateFacilityServiceAreasRequest === undefined) {
            throw new runtime.RequiredError('bulkUpdateFacilityServiceAreasRequest','Required parameter requestParameters.bulkUpdateFacilityServiceAreasRequest was null or undefined when calling bulkUpdateFacilityServiceAreas.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/facilities/{facility_id}/service-areas/bulk`.replace(`{${"facility_id"}}`, encodeURIComponent(String(requestParameters.facilityId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateFacilityServiceAreasRequestToJSON(requestParameters.bulkUpdateFacilityServiceAreasRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkUpdateFacilityServiceAreas200ResponseFromJSON(jsonValue));
    }

    /**
     * Apply the same status and/or notes change to multiple rows
     */
    async bulkUpdateFacilityServiceAreas(requestParameters: BulkUpdateFacilityServiceAreasOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkUpdateFacilityServiceAreas200Response> {
        const response = await this.bulkUpdateFacilityServiceAreasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update screener bed units
     * Update screener bed units
     */
    async bulkUpdateScreenerBedUnitsRaw(requestParameters: BulkUpdateScreenerBedUnitsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllScreenerBedUnits200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling bulkUpdateScreenerBedUnits.');
        }

        if (requestParameters.bulkUpdateScreenerBedUnitsRequest === null || requestParameters.bulkUpdateScreenerBedUnitsRequest === undefined) {
            throw new runtime.RequiredError('bulkUpdateScreenerBedUnitsRequest','Required parameter requestParameters.bulkUpdateScreenerBedUnitsRequest was null or undefined when calling bulkUpdateScreenerBedUnits.');
        }

        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/screener-bed-units`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateScreenerBedUnitsRequestToJSON(requestParameters.bulkUpdateScreenerBedUnitsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllScreenerBedUnits200ResponseFromJSON(jsonValue));
    }

    /**
     * Update screener bed units
     * Update screener bed units
     */
    async bulkUpdateScreenerBedUnits(requestParameters: BulkUpdateScreenerBedUnitsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllScreenerBedUnits200Response> {
        const response = await this.bulkUpdateScreenerBedUnitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Bulk update screener tags
     */
    async bulkUpdateScreenerTagsRaw(requestParameters: BulkUpdateScreenerTagsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllScreenerTags200Response>> {
        if (requestParameters.bulkUpdateScreenerTagsRequest === null || requestParameters.bulkUpdateScreenerTagsRequest === undefined) {
            throw new runtime.RequiredError('bulkUpdateScreenerTagsRequest','Required parameter requestParameters.bulkUpdateScreenerTagsRequest was null or undefined when calling bulkUpdateScreenerTags.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/screener-tags/bulk`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateScreenerTagsRequestToJSON(requestParameters.bulkUpdateScreenerTagsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllScreenerTags200ResponseFromJSON(jsonValue));
    }

    /**
     * Bulk update screener tags
     */
    async bulkUpdateScreenerTags(requestParameters: BulkUpdateScreenerTagsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllScreenerTags200Response> {
        const response = await this.bulkUpdateScreenerTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unified endpoint for checking eligibility of various lead actions (date updates, reverts, etc.)
     * Check eligibility for a lead action
     */
    async checkEligibilityRaw(requestParameters: CheckEligibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckEligibility200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling checkEligibility.');
        }

        if (requestParameters.action === null || requestParameters.action === undefined) {
            throw new runtime.RequiredError('action','Required parameter requestParameters.action was null or undefined when calling checkEligibility.');
        }

        const queryParameters: any = {};

        if (requestParameters.action !== undefined) {
            queryParameters['action'] = requestParameters.action;
        }

        if (requestParameters.date !== undefined) {
            queryParameters['date'] = (requestParameters.date as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/check-eligibility`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckEligibility200ResponseFromJSON(jsonValue));
    }

    /**
     * Unified endpoint for checking eligibility of various lead actions (date updates, reverts, etc.)
     * Check eligibility for a lead action
     */
    async checkEligibility(requestParameters: CheckEligibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckEligibility200Response> {
        const response = await this.checkEligibilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Copy documents from combine leads to the retained lead, then cancel the combine leads
     * Combine documents from multiple leads into a retained lead
     */
    async combineDocumentsRaw(requestParameters: CombineDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CombineDocuments200Response>> {
        if (requestParameters.combineDocumentsRequest === null || requestParameters.combineDocumentsRequest === undefined) {
            throw new runtime.RequiredError('combineDocumentsRequest','Required parameter requestParameters.combineDocumentsRequest was null or undefined when calling combineDocuments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/combine-documents`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CombineDocumentsRequestToJSON(requestParameters.combineDocumentsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CombineDocuments200ResponseFromJSON(jsonValue));
    }

    /**
     * Copy documents from combine leads to the retained lead, then cancel the combine leads
     * Combine documents from multiple leads into a retained lead
     */
    async combineDocuments(requestParameters: CombineDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CombineDocuments200Response> {
        const response = await this.combineDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Combine leads
     * Combine leads
     * @deprecated
     */
    async combineLeadsRaw(requestParameters: CombineLeadsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CombineLeads200Response>> {
        if (requestParameters.combineLeadsRequest === null || requestParameters.combineLeadsRequest === undefined) {
            throw new runtime.RequiredError('combineLeadsRequest','Required parameter requestParameters.combineLeadsRequest was null or undefined when calling combineLeads.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/combine`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CombineLeadsRequestToJSON(requestParameters.combineLeadsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CombineLeads200ResponseFromJSON(jsonValue));
    }

    /**
     * Combine leads
     * Combine leads
     * @deprecated
     */
    async combineLeads(requestParameters: CombineLeadsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CombineLeads200Response> {
        const response = await this.combineLeadsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Copy lead to other facilities
     */
    async copyLeadRaw(requestParameters: CopyLeadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CopyLead201Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling copyLead.');
        }

        if (requestParameters.copyLeadRequest === null || requestParameters.copyLeadRequest === undefined) {
            throw new runtime.RequiredError('copyLeadRequest','Required parameter requestParameters.copyLeadRequest was null or undefined when calling copyLead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/copy`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CopyLeadRequestToJSON(requestParameters.copyLeadRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CopyLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Copy lead to other facilities
     */
    async copyLead(requestParameters: CopyLeadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CopyLead201Response> {
        const response = await this.copyLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Count un-actioned integration events
     */
    async countActiveIntegrationEventsRaw(requestParameters: CountActiveIntegrationEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CountActiveIntegrationEvents200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling countActiveIntegrationEvents.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/facilities/{facility_id}/integration-events/active-count`.replace(`{${"facility_id"}}`, encodeURIComponent(String(requestParameters.facilityId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CountActiveIntegrationEvents200ResponseFromJSON(jsonValue));
    }

    /**
     * Count un-actioned integration events
     */
    async countActiveIntegrationEvents(requestParameters: CountActiveIntegrationEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CountActiveIntegrationEvents200Response> {
        const response = await this.countActiveIntegrationEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a screener criteria
     */
    async createCriteriaRaw(requestParameters: CreateCriteriaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateGlobalCriteria201Response>> {
        if (requestParameters.criteria === null || requestParameters.criteria === undefined) {
            throw new runtime.RequiredError('criteria','Required parameter requestParameters.criteria was null or undefined when calling createCriteria.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/criteria`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CriteriaToJSON(requestParameters.criteria),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateGlobalCriteria201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a screener criteria
     */
    async createCriteria(requestParameters: CreateCriteriaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateGlobalCriteria201Response> {
        const response = await this.createCriteriaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a criteria category
     * Create a criteria category
     */
    async createCriteriaCategoryRaw(requestParameters: CreateCriteriaCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCriteriaCategory201Response>> {
        if (requestParameters.criteriaCategory === null || requestParameters.criteriaCategory === undefined) {
            throw new runtime.RequiredError('criteriaCategory','Required parameter requestParameters.criteriaCategory was null or undefined when calling createCriteriaCategory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/criteria/categories`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CriteriaCategoryToJSON(requestParameters.criteriaCategory),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCriteriaCategory201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a criteria category
     * Create a criteria category
     */
    async createCriteriaCategory(requestParameters: CreateCriteriaCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCriteriaCategory201Response> {
        const response = await this.createCriteriaCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a screener criteria and its facility/system-tag targets in a single transaction
     * Create a criteria with targets
     */
    async createCriteriaTargetsRaw(requestParameters: CreateCriteriaTargetsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCriteriaTargets201Response>> {
        if (requestParameters.createCriteriaTargetsRequest === null || requestParameters.createCriteriaTargetsRequest === undefined) {
            throw new runtime.RequiredError('createCriteriaTargetsRequest','Required parameter requestParameters.createCriteriaTargetsRequest was null or undefined when calling createCriteriaTargets.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/criteria/targets`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCriteriaTargetsRequestToJSON(requestParameters.createCriteriaTargetsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCriteriaTargets201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a screener criteria and its facility/system-tag targets in a single transaction
     * Create a criteria with targets
     */
    async createCriteriaTargets(requestParameters: CreateCriteriaTargetsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCriteriaTargets201Response> {
        const response = await this.createCriteriaTargetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new document exclusion term for a specific organization and facility
     * Create document exclusion term
     */
    async createDocumentExclusionTermRaw(requestParameters: CreateDocumentExclusionTermOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateDocumentExclusionTerm201Response>> {
        if (requestParameters.createDocumentExclusionTermRequest === null || requestParameters.createDocumentExclusionTermRequest === undefined) {
            throw new runtime.RequiredError('createDocumentExclusionTermRequest','Required parameter requestParameters.createDocumentExclusionTermRequest was null or undefined when calling createDocumentExclusionTerm.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/document-exclusion-terms`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDocumentExclusionTermRequestToJSON(requestParameters.createDocumentExclusionTermRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateDocumentExclusionTerm201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new document exclusion term for a specific organization and facility
     * Create document exclusion term
     */
    async createDocumentExclusionTerm(requestParameters: CreateDocumentExclusionTermOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateDocumentExclusionTerm201Response> {
        const response = await this.createDocumentExclusionTermRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a facility region and assign its facilities
     */
    async createFacilityRegionRaw(requestParameters: CreateFacilityRegionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFacilityRegion201Response>> {
        if (requestParameters.createFacilityRegionRequest === null || requestParameters.createFacilityRegionRequest === undefined) {
            throw new runtime.RequiredError('createFacilityRegionRequest','Required parameter requestParameters.createFacilityRegionRequest was null or undefined when calling createFacilityRegion.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/facility-regions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFacilityRegionRequestToJSON(requestParameters.createFacilityRegionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFacilityRegion201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a facility region and assign its facilities
     */
    async createFacilityRegion(requestParameters: CreateFacilityRegionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFacilityRegion201Response> {
        const response = await this.createFacilityRegionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a service area entry for a facility
     */
    async createFacilityServiceAreaRaw(requestParameters: CreateFacilityServiceAreaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFacilityServiceArea201Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling createFacilityServiceArea.');
        }

        if (requestParameters.createFacilityServiceAreaRequest === null || requestParameters.createFacilityServiceAreaRequest === undefined) {
            throw new runtime.RequiredError('createFacilityServiceAreaRequest','Required parameter requestParameters.createFacilityServiceAreaRequest was null or undefined when calling createFacilityServiceArea.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/facilities/{facility_id}/service-areas`.replace(`{${"facility_id"}}`, encodeURIComponent(String(requestParameters.facilityId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFacilityServiceAreaRequestToJSON(requestParameters.createFacilityServiceAreaRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFacilityServiceArea201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a service area entry for a facility
     */
    async createFacilityServiceArea(requestParameters: CreateFacilityServiceAreaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFacilityServiceArea201Response> {
        const response = await this.createFacilityServiceAreaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a short-lived signed S3 URL the client can `PUT` the CSV to, plus the `s3_key` to pass to the bulk-import endpoint. 
     * Get a presigned S3 URL for uploading a service area CSV
     */
    async createFacilityServiceAreaUploadUrlRaw(requestParameters: CreateFacilityServiceAreaUploadUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFacilityServiceAreaUploadUrl200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling createFacilityServiceAreaUploadUrl.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/facilities/{facility_id}/service-areas/upload-url`.replace(`{${"facility_id"}}`, encodeURIComponent(String(requestParameters.facilityId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFacilityServiceAreaUploadUrl200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns a short-lived signed S3 URL the client can `PUT` the CSV to, plus the `s3_key` to pass to the bulk-import endpoint. 
     * Get a presigned S3 URL for uploading a service area CSV
     */
    async createFacilityServiceAreaUploadUrl(requestParameters: CreateFacilityServiceAreaUploadUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFacilityServiceAreaUploadUrl200Response> {
        const response = await this.createFacilityServiceAreaUploadUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new referral from a fax document
     */
    async createFaxReferralRaw(requestParameters: CreateFaxReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createFaxReferral.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/efax/faxes/{id}/create-referral`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a new referral from a fax document
     */
    async createFaxReferral(requestParameters: CreateFaxReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createFaxReferralRaw(requestParameters, initOverrides);
    }

    /**
     * Create a filter view
     */
    async createFilterViewRaw(requestParameters: CreateFilterViewOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFilterView201Response>> {
        if (requestParameters.createFilterViewRequest === null || requestParameters.createFilterViewRequest === undefined) {
            throw new runtime.RequiredError('createFilterViewRequest','Required parameter requestParameters.createFilterViewRequest was null or undefined when calling createFilterView.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/filter-views`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFilterViewRequestToJSON(requestParameters.createFilterViewRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFilterView201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a filter view
     */
    async createFilterView(requestParameters: CreateFilterViewOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFilterView201Response> {
        const response = await this.createFilterViewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a global screener criteria
     */
    async createGlobalCriteriaRaw(requestParameters: CreateGlobalCriteriaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateGlobalCriteria201Response>> {
        if (requestParameters.criteria === null || requestParameters.criteria === undefined) {
            throw new runtime.RequiredError('criteria','Required parameter requestParameters.criteria was null or undefined when calling createGlobalCriteria.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/criteria/global`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CriteriaToJSON(requestParameters.criteria),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateGlobalCriteria201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a global screener criteria
     */
    async createGlobalCriteria(requestParameters: CreateGlobalCriteriaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateGlobalCriteria201Response> {
        const response = await this.createGlobalCriteriaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create lead additional documents
     */
    async createLeadAdditionalDocumentsRaw(requestParameters: CreateLeadAdditionalDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling createLeadAdditionalDocuments.');
        }

        if (requestParameters.createLeadAdditionalDocumentsRequest === null || requestParameters.createLeadAdditionalDocumentsRequest === undefined) {
            throw new runtime.RequiredError('createLeadAdditionalDocumentsRequest','Required parameter requestParameters.createLeadAdditionalDocumentsRequest was null or undefined when calling createLeadAdditionalDocuments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/additional-documents/bulk`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLeadAdditionalDocumentsRequestToJSON(requestParameters.createLeadAdditionalDocumentsRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create lead additional documents
     */
    async createLeadAdditionalDocuments(requestParameters: CreateLeadAdditionalDocumentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createLeadAdditionalDocumentsRaw(requestParameters, initOverrides);
    }

    /**
     * Create a screener lead info
     */
    async createLeadInfoRaw(requestParameters: CreateLeadInfoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLeadInfo201Response>> {
        if (requestParameters.createLeadInfoRequest === null || requestParameters.createLeadInfoRequest === undefined) {
            throw new runtime.RequiredError('createLeadInfoRequest','Required parameter requestParameters.createLeadInfoRequest was null or undefined when calling createLeadInfo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/lead-info`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLeadInfoRequestToJSON(requestParameters.createLeadInfoRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLeadInfo201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a screener lead info
     */
    async createLeadInfo(requestParameters: CreateLeadInfoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLeadInfo201Response> {
        const response = await this.createLeadInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a lead waitlist record
     */
    async createLeadWaitlistRaw(requestParameters: CreateLeadWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLeadWaitlistStatus200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling createLeadWaitlist.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/waitlist`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateLeadWaitlistStatus200ResponseFromJSON(jsonValue));
    }

    /**
     * Create a lead waitlist record
     */
    async createLeadWaitlist(requestParameters: CreateLeadWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLeadWaitlistStatus200Response> {
        const response = await this.createLeadWaitlistRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a lead waitlist update record
     */
    async createLeadWaitlistUpdateRaw(requestParameters: CreateLeadWaitlistUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLeadWaitlistUpdate201Response>> {
        if (requestParameters.waitlistId === null || requestParameters.waitlistId === undefined) {
            throw new runtime.RequiredError('waitlistId','Required parameter requestParameters.waitlistId was null or undefined when calling createLeadWaitlistUpdate.');
        }

        if (requestParameters.findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner === null || requestParameters.findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner === undefined) {
            throw new runtime.RequiredError('findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner','Required parameter requestParameters.findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner was null or undefined when calling createLeadWaitlistUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/lead-waitlist/{waitlist_id}/updates`.replace(`{${"waitlist_id"}}`, encodeURIComponent(String(requestParameters.waitlistId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInnerToJSON(requestParameters.findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLeadWaitlistUpdate201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a lead waitlist update record
     */
    async createLeadWaitlistUpdate(requestParameters: CreateLeadWaitlistUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLeadWaitlistUpdate201Response> {
        const response = await this.createLeadWaitlistUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create multiple screener leads for specified facilities
     */
    async createLeadsBulkRaw(requestParameters: CreateLeadsBulkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.createLeadsBulkRequest === null || requestParameters.createLeadsBulkRequest === undefined) {
            throw new runtime.RequiredError('createLeadsBulkRequest','Required parameter requestParameters.createLeadsBulkRequest was null or undefined when calling createLeadsBulk.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/bulk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLeadsBulkRequestToJSON(requestParameters.createLeadsBulkRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create multiple screener leads for specified facilities
     */
    async createLeadsBulk(requestParameters: CreateLeadsBulkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createLeadsBulkRaw(requestParameters, initOverrides);
    }

    /**
     * Create a MatrixCare patient
     */
    async createMatrixCarePatientRaw(requestParameters: CreateMatrixCarePatientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateMatrixCarePatient201Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling createMatrixCarePatient.');
        }

        if (requestParameters.createMatrixCarePatientRequest === null || requestParameters.createMatrixCarePatientRequest === undefined) {
            throw new runtime.RequiredError('createMatrixCarePatientRequest','Required parameter requestParameters.createMatrixCarePatientRequest was null or undefined when calling createMatrixCarePatient.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/matrix-care/patient`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMatrixCarePatientRequestToJSON(requestParameters.createMatrixCarePatientRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateMatrixCarePatient201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a MatrixCare patient
     */
    async createMatrixCarePatient(requestParameters: CreateMatrixCarePatientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateMatrixCarePatient201Response> {
        const response = await this.createMatrixCarePatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create details for a MatrixCare patient
     */
    async createMatrixCarePatientDetailsRaw(requestParameters: CreateMatrixCarePatientDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneMatrixCarePatientDetails200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling createMatrixCarePatientDetails.');
        }

        if (requestParameters.matrixCarePatientDetails === null || requestParameters.matrixCarePatientDetails === undefined) {
            throw new runtime.RequiredError('matrixCarePatientDetails','Required parameter requestParameters.matrixCarePatientDetails was null or undefined when calling createMatrixCarePatientDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/matrix-care/patient/details`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MatrixCarePatientDetailsToJSON(requestParameters.matrixCarePatientDetails),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneMatrixCarePatientDetails200ResponseFromJSON(jsonValue));
    }

    /**
     * Create details for a MatrixCare patient
     */
    async createMatrixCarePatientDetails(requestParameters: CreateMatrixCarePatientDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneMatrixCarePatientDetails200Response> {
        const response = await this.createMatrixCarePatientDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a new IP address to the organization\'s whitelist
     * Create IP whitelist entry for an organization
     */
    async createOrganizationIPWhitelistRaw(requestParameters: CreateOrganizationIPWhitelistOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateOrganizationIPWhitelistResponse>> {
        if (requestParameters.createOrganizationIPWhitelistRequest === null || requestParameters.createOrganizationIPWhitelistRequest === undefined) {
            throw new runtime.RequiredError('createOrganizationIPWhitelistRequest','Required parameter requestParameters.createOrganizationIPWhitelistRequest was null or undefined when calling createOrganizationIPWhitelist.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ip-whitelist`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrganizationIPWhitelistRequestToJSON(requestParameters.createOrganizationIPWhitelistRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateOrganizationIPWhitelistResponseFromJSON(jsonValue));
    }

    /**
     * Add a new IP address to the organization\'s whitelist
     * Create IP whitelist entry for an organization
     */
    async createOrganizationIPWhitelist(requestParameters: CreateOrganizationIPWhitelistOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateOrganizationIPWhitelistResponse> {
        const response = await this.createOrganizationIPWhitelistRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a screener organization state
     */
    async createOrganizationStateRaw(requestParameters: CreateOrganizationStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateOrganizationState201Response>> {
        if (requestParameters.organizationState === null || requestParameters.organizationState === undefined) {
            throw new runtime.RequiredError('organizationState','Required parameter requestParameters.organizationState was null or undefined when calling createOrganizationState.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/organization-states`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationStateToJSON(requestParameters.organizationState),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateOrganizationState201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a screener organization state
     */
    async createOrganizationState(requestParameters: CreateOrganizationStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateOrganizationState201Response> {
        const response = await this.createOrganizationStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create multiple towns for an organization state
     */
    async createOrganizationStateTownsBulkRaw(requestParameters: CreateOrganizationStateTownsBulkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateOrganizationStateTownsBulk201Response>> {
        if (requestParameters.createOrganizationStateTownsBulkRequest === null || requestParameters.createOrganizationStateTownsBulkRequest === undefined) {
            throw new runtime.RequiredError('createOrganizationStateTownsBulkRequest','Required parameter requestParameters.createOrganizationStateTownsBulkRequest was null or undefined when calling createOrganizationStateTownsBulk.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/organization-state-towns/bulk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrganizationStateTownsBulkRequestToJSON(requestParameters.createOrganizationStateTownsBulkRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateOrganizationStateTownsBulk201ResponseFromJSON(jsonValue));
    }

    /**
     * Create multiple towns for an organization state
     */
    async createOrganizationStateTownsBulk(requestParameters: CreateOrganizationStateTownsBulkOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateOrganizationStateTownsBulk201Response> {
        const response = await this.createOrganizationStateTownsBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a referral recipient config for an accessible sender facility
     */
    async createReferralRecipientConfigRaw(requestParameters: CreateReferralRecipientConfigOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateReferralRecipientConfig201Response>> {
        if (requestParameters.createReferralRecipientConfigRequest === null || requestParameters.createReferralRecipientConfigRequest === undefined) {
            throw new runtime.RequiredError('createReferralRecipientConfigRequest','Required parameter requestParameters.createReferralRecipientConfigRequest was null or undefined when calling createReferralRecipientConfig.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/referral-recipient-configs`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateReferralRecipientConfigRequestToJSON(requestParameters.createReferralRecipientConfigRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateReferralRecipientConfig201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a referral recipient config for an accessible sender facility
     */
    async createReferralRecipientConfig(requestParameters: CreateReferralRecipientConfigOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateReferralRecipientConfig201Response> {
        const response = await this.createReferralRecipientConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a screener admission flag
     * Create a screener admission flag
     */
    async createScreenerAdmissionFlagRaw(requestParameters: CreateScreenerAdmissionFlagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateScreenerAdmissionFlag201Response>> {
        if (requestParameters.findAllScreenerAdmissionFlags200ResponseDataInner === null || requestParameters.findAllScreenerAdmissionFlags200ResponseDataInner === undefined) {
            throw new runtime.RequiredError('findAllScreenerAdmissionFlags200ResponseDataInner','Required parameter requestParameters.findAllScreenerAdmissionFlags200ResponseDataInner was null or undefined when calling createScreenerAdmissionFlag.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/screener-admission-flags`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FindAllScreenerAdmissionFlags200ResponseDataInnerToJSON(requestParameters.findAllScreenerAdmissionFlags200ResponseDataInner),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateScreenerAdmissionFlag201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a screener admission flag
     * Create a screener admission flag
     */
    async createScreenerAdmissionFlag(requestParameters: CreateScreenerAdmissionFlagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateScreenerAdmissionFlag201Response> {
        const response = await this.createScreenerAdmissionFlagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a screener lead tag
     * Create a screener lead tag
     */
    async createScreenerLeadTagRaw(requestParameters: CreateScreenerLeadTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateScreenerLeadTag201Response>> {
        if (requestParameters.findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner === null || requestParameters.findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner === undefined) {
            throw new runtime.RequiredError('findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner','Required parameter requestParameters.findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner was null or undefined when calling createScreenerLeadTag.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/screener-lead-tags`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerToJSON(requestParameters.findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInner),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateScreenerLeadTag201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a screener lead tag
     * Create a screener lead tag
     */
    async createScreenerLeadTag(requestParameters: CreateScreenerLeadTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateScreenerLeadTag201Response> {
        const response = await this.createScreenerLeadTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a screener source tag
     */
    async createSourceTagRaw(requestParameters: CreateSourceTagOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSourceTag201Response>> {
        if (requestParameters.createSourceTagRequest === null || requestParameters.createSourceTagRequest === undefined) {
            throw new runtime.RequiredError('createSourceTagRequest','Required parameter requestParameters.createSourceTagRequest was null or undefined when calling createSourceTag.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/source-tags`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSourceTagRequestToJSON(requestParameters.createSourceTagRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSourceTag201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a screener source tag
     */
    async createSourceTag(requestParameters: CreateSourceTagOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSourceTag201Response> {
        const response = await this.createSourceTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete additional document for a screener lead by ID
     */
    async deleteAdditionalDocumentForLeadRaw(requestParameters: DeleteAdditionalDocumentForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling deleteAdditionalDocumentForLead.');
        }

        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling deleteAdditionalDocumentForLead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/additional-documents/{document_id}`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))).replace(`{${"document_id"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete additional document for a screener lead by ID
     */
    async deleteAdditionalDocumentForLead(requestParameters: DeleteAdditionalDocumentForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAdditionalDocumentForLeadRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a criteria
     * Delete a criteria
     */
    async deleteCriteriaRaw(requestParameters: DeleteCriteriaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.criteriaId === null || requestParameters.criteriaId === undefined) {
            throw new runtime.RequiredError('criteriaId','Required parameter requestParameters.criteriaId was null or undefined when calling deleteCriteria.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/criteria/{criteria_id}`.replace(`{${"criteria_id"}}`, encodeURIComponent(String(requestParameters.criteriaId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a criteria
     * Delete a criteria
     */
    async deleteCriteria(requestParameters: DeleteCriteriaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCriteriaRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a criteria category
     * Delete a criteria category
     */
    async deleteCriteriaCategoryRaw(requestParameters: DeleteCriteriaCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId','Required parameter requestParameters.categoryId was null or undefined when calling deleteCriteriaCategory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/criteria/categories/{category_id}`.replace(`{${"category_id"}}`, encodeURIComponent(String(requestParameters.categoryId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a criteria category
     * Delete a criteria category
     */
    async deleteCriteriaCategory(requestParameters: DeleteCriteriaCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCriteriaCategoryRaw(requestParameters, initOverrides);
    }

    /**
     * Soft delete a screener criteria and all of its targets in a single transaction
     * Delete a criteria and its targets
     */
    async deleteCriteriaTargetsRaw(requestParameters: DeleteCriteriaTargetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.criteriaId === null || requestParameters.criteriaId === undefined) {
            throw new runtime.RequiredError('criteriaId','Required parameter requestParameters.criteriaId was null or undefined when calling deleteCriteriaTargets.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/criteria/targets/{criteria_id}`.replace(`{${"criteria_id"}}`, encodeURIComponent(String(requestParameters.criteriaId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Soft delete a screener criteria and all of its targets in a single transaction
     * Delete a criteria and its targets
     */
    async deleteCriteriaTargets(requestParameters: DeleteCriteriaTargetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCriteriaTargetsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete an existing document exclusion term
     * Delete document exclusion term
     */
    async deleteDocumentExclusionTermRaw(requestParameters: DeleteDocumentExclusionTermRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.termId === null || requestParameters.termId === undefined) {
            throw new runtime.RequiredError('termId','Required parameter requestParameters.termId was null or undefined when calling deleteDocumentExclusionTerm.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/document-exclusion-terms/{term_id}`.replace(`{${"term_id"}}`, encodeURIComponent(String(requestParameters.termId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an existing document exclusion term
     * Delete document exclusion term
     */
    async deleteDocumentExclusionTerm(requestParameters: DeleteDocumentExclusionTermRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDocumentExclusionTermRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a facility region and detach its facilities
     */
    async deleteFacilityRegionRaw(requestParameters: DeleteFacilityRegionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteFacilityRegion200Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteFacilityRegion.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/facility-regions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteFacilityRegion200ResponseFromJSON(jsonValue));
    }

    /**
     * Delete a facility region and detach its facilities
     */
    async deleteFacilityRegion(requestParameters: DeleteFacilityRegionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteFacilityRegion200Response> {
        const response = await this.deleteFacilityRegionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a service area entry for a facility
     */
    async deleteFacilityServiceAreaRaw(requestParameters: DeleteFacilityServiceAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling deleteFacilityServiceArea.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteFacilityServiceArea.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/facilities/{facility_id}/service-areas/{id}`.replace(`{${"facility_id"}}`, encodeURIComponent(String(requestParameters.facilityId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a service area entry for a facility
     */
    async deleteFacilityServiceArea(requestParameters: DeleteFacilityServiceAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteFacilityServiceAreaRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a filter view
     */
    async deleteFilterViewByIdRaw(requestParameters: DeleteFilterViewByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteFilterViewById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/filter-views/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a filter view
     */
    async deleteFilterViewById(requestParameters: DeleteFilterViewByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteFilterViewByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Remove an IP address from the organization\'s whitelist
     * Delete IP whitelist entry
     */
    async deleteOrganizationIPWhitelistRaw(requestParameters: DeleteOrganizationIPWhitelistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteOrganizationIPWhitelistResponse>> {
        if (requestParameters.ipAddress === null || requestParameters.ipAddress === undefined) {
            throw new runtime.RequiredError('ipAddress','Required parameter requestParameters.ipAddress was null or undefined when calling deleteOrganizationIPWhitelist.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ip-whitelist/{ip_address}`.replace(`{${"ip_address"}}`, encodeURIComponent(String(requestParameters.ipAddress))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteOrganizationIPWhitelistResponseFromJSON(jsonValue));
    }

    /**
     * Remove an IP address from the organization\'s whitelist
     * Delete IP whitelist entry
     */
    async deleteOrganizationIPWhitelist(requestParameters: DeleteOrganizationIPWhitelistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteOrganizationIPWhitelistResponse> {
        const response = await this.deleteOrganizationIPWhitelistRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a screener organization state
     */
    async deleteOrganizationStateByIdRaw(requestParameters: DeleteOrganizationStateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteOrganizationStateById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/organization-states/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a screener organization state
     */
    async deleteOrganizationStateById(requestParameters: DeleteOrganizationStateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteOrganizationStateByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a screener organization state town
     */
    async deleteOrganizationStateTownByIdRaw(requestParameters: DeleteOrganizationStateTownByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteOrganizationStateTownById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/organization-state-towns/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a screener organization state town
     */
    async deleteOrganizationStateTownById(requestParameters: DeleteOrganizationStateTownByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteOrganizationStateTownByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Soft-delete a referral recipient config
     */
    async deleteReferralRecipientConfigRaw(requestParameters: DeleteReferralRecipientConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReferralRecipientConfig200Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteReferralRecipientConfig.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/referral-recipient-configs/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReferralRecipientConfig200ResponseFromJSON(jsonValue));
    }

    /**
     * Soft-delete a referral recipient config
     */
    async deleteReferralRecipientConfig(requestParameters: DeleteReferralRecipientConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReferralRecipientConfig200Response> {
        const response = await this.deleteReferralRecipientConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a screener admission flag by ID
     */
    async deleteScreenerAdmissionFlagByIdRaw(requestParameters: DeleteScreenerAdmissionFlagByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteScreenerAdmissionFlagById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-admission-flags/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a screener admission flag by ID
     */
    async deleteScreenerAdmissionFlagById(requestParameters: DeleteScreenerAdmissionFlagByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteScreenerAdmissionFlagByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Delete screener lead tag
     * Delete screener lead tag
     */
    async deleteScreenerLeadTagRaw(requestParameters: DeleteScreenerLeadTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteScreenerLeadTag.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-lead-tags/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete screener lead tag
     * Delete screener lead tag
     */
    async deleteScreenerLeadTag(requestParameters: DeleteScreenerLeadTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteScreenerLeadTagRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a screener tag by ID
     */
    async deleteScreenerTagByIdRaw(requestParameters: DeleteScreenerTagByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteScreenerTagById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-tags/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a screener tag by ID
     */
    async deleteScreenerTagById(requestParameters: DeleteScreenerTagByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteScreenerTagByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Exchange a lead to another facility
     */
    async exchangeLeadRaw(requestParameters: ExchangeLeadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExchangeLeadResponse>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling exchangeLead.');
        }

        if (requestParameters.exchangeLeadRequest === null || requestParameters.exchangeLeadRequest === undefined) {
            throw new runtime.RequiredError('exchangeLeadRequest','Required parameter requestParameters.exchangeLeadRequest was null or undefined when calling exchangeLead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/exchange`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExchangeLeadRequestToJSON(requestParameters.exchangeLeadRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExchangeLeadResponseFromJSON(jsonValue));
    }

    /**
     * Exchange a lead to another facility
     */
    async exchangeLead(requestParameters: ExchangeLeadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExchangeLeadResponse> {
        const response = await this.exchangeLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Apply a review stage decision to multiple instances
     */
    async executeInstanceBulkDecisionRaw(requestParameters: ExecuteInstanceBulkDecisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExecuteInstanceBulkDecision200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling executeInstanceBulkDecision.');
        }

        if (requestParameters.instanceBulkDecisionRequest === null || requestParameters.instanceBulkDecisionRequest === undefined) {
            throw new runtime.RequiredError('instanceBulkDecisionRequest','Required parameter requestParameters.instanceBulkDecisionRequest was null or undefined when calling executeInstanceBulkDecision.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/bulk-decision`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InstanceBulkDecisionRequestToJSON(requestParameters.instanceBulkDecisionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExecuteInstanceBulkDecision200ResponseFromJSON(jsonValue));
    }

    /**
     * Apply a review stage decision to multiple instances
     */
    async executeInstanceBulkDecision(requestParameters: ExecuteInstanceBulkDecisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExecuteInstanceBulkDecision200Response> {
        const response = await this.executeInstanceBulkDecisionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark multiple instances as Lost
     */
    async executeInstanceBulkLostRaw(requestParameters: ExecuteInstanceBulkLostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExecuteInstanceBulkDecision200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling executeInstanceBulkLost.');
        }

        if (requestParameters.instanceBulkLostRequest === null || requestParameters.instanceBulkLostRequest === undefined) {
            throw new runtime.RequiredError('instanceBulkLostRequest','Required parameter requestParameters.instanceBulkLostRequest was null or undefined when calling executeInstanceBulkLost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/bulk-lost`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InstanceBulkLostRequestToJSON(requestParameters.instanceBulkLostRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExecuteInstanceBulkDecision200ResponseFromJSON(jsonValue));
    }

    /**
     * Mark multiple instances as Lost
     */
    async executeInstanceBulkLost(requestParameters: ExecuteInstanceBulkLostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExecuteInstanceBulkDecision200Response> {
        const response = await this.executeInstanceBulkLostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all bed rooms
     * Find all bed rooms
     */
    async findAllBedRoomsRaw(requestParameters: FindAllBedRoomsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllBedRooms200Response>> {
        if (requestParameters.unitId === null || requestParameters.unitId === undefined) {
            throw new runtime.RequiredError('unitId','Required parameter requestParameters.unitId was null or undefined when calling findAllBedRooms.');
        }

        const queryParameters: any = {};

        if (requestParameters.unitId !== undefined) {
            queryParameters['unit_id'] = requestParameters.unitId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bed-rooms`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllBedRooms200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all bed rooms
     * Find all bed rooms
     */
    async findAllBedRooms(requestParameters: FindAllBedRoomsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllBedRooms200Response> {
        const response = await this.findAllBedRoomsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve bed types
     * Fine all bed types
     */
    async findAllBedTypesRaw(requestParameters: FindAllBedTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllBedTypes200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling findAllBedTypes.');
        }

        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/bed-types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllBedTypes200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve bed types
     * Fine all bed types
     */
    async findAllBedTypes(requestParameters: FindAllBedTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllBedTypes200Response> {
        const response = await this.findAllBedTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve beds for a facility
     * Find all beds
     */
    async findAllBedsRaw(requestParameters: FindAllBedsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllBeds200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling findAllBeds.');
        }

        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        if (requestParameters.bedTypeIds !== undefined) {
            queryParameters['bed_type_ids'] = requestParameters.bedTypeIds;
        }

        if (requestParameters.includeOccupied !== undefined) {
            queryParameters['include_occupied'] = requestParameters.includeOccupied;
        }

        if (requestParameters.availabilityFrom !== undefined) {
            queryParameters['availability_from'] = requestParameters.availabilityFrom;
        }

        if (requestParameters.availabilityTo !== undefined) {
            queryParameters['availability_to'] = requestParameters.availabilityTo;
        }

        if (requestParameters.roomId !== undefined) {
            queryParameters['room_id'] = requestParameters.roomId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/beds`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllBeds200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve beds for a facility
     * Find all beds
     */
    async findAllBeds(requestParameters: FindAllBedsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllBeds200Response> {
        const response = await this.findAllBedsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all criteria
     * Find all criteria
     */
    async findAllCriteriaRaw(requestParameters: FindAllCriteriaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllCriteria200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling findAllCriteria.');
        }

        if (requestParameters.isInformational === null || requestParameters.isInformational === undefined) {
            throw new runtime.RequiredError('isInformational','Required parameter requestParameters.isInformational was null or undefined when calling findAllCriteria.');
        }

        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        if (requestParameters.isInformational !== undefined) {
            queryParameters['is_informational'] = requestParameters.isInformational;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/criteria`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllCriteria200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all criteria
     * Find all criteria
     */
    async findAllCriteria(requestParameters: FindAllCriteriaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllCriteria200Response> {
        const response = await this.findAllCriteriaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all criteria categories
     * Find all criteria categories
     */
    async findAllCriteriaCategoriesRaw(requestParameters: FindAllCriteriaCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllCriteriaCategories200Response>> {
        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/criteria/categories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllCriteriaCategories200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all criteria categories
     * Find all criteria categories
     */
    async findAllCriteriaCategories(requestParameters: FindAllCriteriaCategoriesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllCriteriaCategories200Response> {
        const response = await this.findAllCriteriaCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all criteria grouped with their facility/system-tag targets
     * Find all criteria targets
     */
    async findAllCriteriaTargetsRaw(requestParameters: FindAllCriteriaTargetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllCriteriaTargets200Response>> {
        const queryParameters: any = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.criteriaType !== undefined) {
            queryParameters['criteria_type'] = requestParameters.criteriaType;
        }

        if (requestParameters.categoryId !== undefined) {
            queryParameters['category_id'] = requestParameters.categoryId;
        }

        if (requestParameters.qualifier !== undefined) {
            queryParameters['qualifier'] = requestParameters.qualifier;
        }

        if (requestParameters.appliesToFacilityId !== undefined) {
            queryParameters['applies_to_facility_id'] = requestParameters.appliesToFacilityId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/criteria/targets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllCriteriaTargets200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all criteria grouped with their facility/system-tag targets
     * Find all criteria targets
     */
    async findAllCriteriaTargets(requestParameters: FindAllCriteriaTargetsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllCriteriaTargets200Response> {
        const response = await this.findAllCriteriaTargetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get screener executions available for facilites
     */
    async findAllExecutionsAvailableByFacilityIdRaw(requestParameters: FindAllExecutionsAvailableByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllExecutionsAvailableByFacilityId200Response>> {
        if (requestParameters.facilityIds === null || requestParameters.facilityIds === undefined) {
            throw new runtime.RequiredError('facilityIds','Required parameter requestParameters.facilityIds was null or undefined when calling findAllExecutionsAvailableByFacilityId.');
        }

        const queryParameters: any = {};

        if (requestParameters.facilityIds !== undefined) {
            queryParameters['facility_ids'] = requestParameters.facilityIds;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/facilities/executions-available`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllExecutionsAvailableByFacilityId200ResponseFromJSON(jsonValue));
    }

    /**
     * Get screener executions available for facilites
     */
    async findAllExecutionsAvailableByFacilityId(requestParameters: FindAllExecutionsAvailableByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllExecutionsAvailableByFacilityId200Response> {
        const response = await this.findAllExecutionsAvailableByFacilityIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List the organization\'s facility regions
     */
    async findAllFacilityRegionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllFacilityRegions200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/facility-regions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllFacilityRegions200ResponseFromJSON(jsonValue));
    }

    /**
     * List the organization\'s facility regions
     */
    async findAllFacilityRegions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllFacilityRegions200Response> {
        const response = await this.findAllFacilityRegionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns the facility\'s configured service areas (Accept/Review/Decline). Returns an empty list when the `service_area_enabled` screener setting is not Enabled for the facility. 
     * Find all service areas for a facility
     */
    async findAllFacilityServiceAreasRaw(requestParameters: FindAllFacilityServiceAreasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllFacilityServiceAreas200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling findAllFacilityServiceAreas.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/facilities/{facility_id}/service-areas`.replace(`{${"facility_id"}}`, encodeURIComponent(String(requestParameters.facilityId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllFacilityServiceAreas200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns the facility\'s configured service areas (Accept/Review/Decline). Returns an empty list when the `service_area_enabled` screener setting is not Enabled for the facility. 
     * Find all service areas for a facility
     */
    async findAllFacilityServiceAreas(requestParameters: FindAllFacilityServiceAreasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllFacilityServiceAreas200Response> {
        const response = await this.findAllFacilityServiceAreasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a paginated list of faxes a facility or organization has received
     */
    async findAllFaxesRaw(requestParameters: FindAllFaxesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllFaxes200Response>> {
        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        if (requestParameters.facilityType !== undefined) {
            queryParameters['facility_type'] = requestParameters.facilityType;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/efax/faxes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllFaxes200ResponseFromJSON(jsonValue));
    }

    /**
     * Get a paginated list of faxes a facility or organization has received
     */
    async findAllFaxes(requestParameters: FindAllFaxesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllFaxes200Response> {
        const response = await this.findAllFaxesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all filter views for the current user and scope
     */
    async findAllFilterViewsRaw(requestParameters: FindAllFilterViewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllFilterViews200Response>> {
        if (requestParameters.scope === null || requestParameters.scope === undefined) {
            throw new runtime.RequiredError('scope','Required parameter requestParameters.scope was null or undefined when calling findAllFilterViews.');
        }

        if (requestParameters.viewKey === null || requestParameters.viewKey === undefined) {
            throw new runtime.RequiredError('viewKey','Required parameter requestParameters.viewKey was null or undefined when calling findAllFilterViews.');
        }

        const queryParameters: any = {};

        if (requestParameters.scope !== undefined) {
            queryParameters['scope'] = requestParameters.scope;
        }

        if (requestParameters.viewKey !== undefined) {
            queryParameters['view_key'] = requestParameters.viewKey;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/filter-views`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllFilterViews200ResponseFromJSON(jsonValue));
    }

    /**
     * Find all filter views for the current user and scope
     */
    async findAllFilterViews(requestParameters: FindAllFilterViewsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllFilterViews200Response> {
        const response = await this.findAllFilterViewsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all ICD 10 codes
     */
    async findAllIcd10CodesRaw(requestParameters: FindAllIcd10CodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllIcd10Codes200Response>> {
        const queryParameters: any = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/icd10-codes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllIcd10Codes200ResponseFromJSON(jsonValue));
    }

    /**
     * Find all ICD 10 codes
     */
    async findAllIcd10Codes(requestParameters: FindAllIcd10CodesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllIcd10Codes200Response> {
        const response = await this.findAllIcd10CodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all integration events by facility ID
     */
    async findAllIntegrationEventsByFacilityIdRaw(requestParameters: FindAllIntegrationEventsByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllIntegrationEventsByFacilityId200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling findAllIntegrationEventsByFacilityId.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/integration-events/{facility_id}`.replace(`{${"facility_id"}}`, encodeURIComponent(String(requestParameters.facilityId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllIntegrationEventsByFacilityId200ResponseFromJSON(jsonValue));
    }

    /**
     * Find all integration events by facility ID
     */
    async findAllIntegrationEventsByFacilityId(requestParameters: FindAllIntegrationEventsByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllIntegrationEventsByFacilityId200Response> {
        const response = await this.findAllIntegrationEventsByFacilityIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all IP addresses whitelisted for an organization
     * Find all IP whitelist entries for an organization
     */
    async findAllOrganizationIPWhitelistRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllOrganizationIPWhitelistResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ip-whitelist`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllOrganizationIPWhitelistResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all IP addresses whitelisted for an organization
     * Find all IP whitelist entries for an organization
     */
    async findAllOrganizationIPWhitelist(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllOrganizationIPWhitelistResponse> {
        const response = await this.findAllOrganizationIPWhitelistRaw(initOverrides);
        return await response.value();
    }

    /**
     * Fine all organization states
     */
    async findAllOrganizationStatesRaw(requestParameters: FindAllOrganizationStatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllOrganizationStates200Response>> {
        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type','Required parameter requestParameters.type was null or undefined when calling findAllOrganizationStates.');
        }

        const queryParameters: any = {};

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/organization-states`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllOrganizationStates200ResponseFromJSON(jsonValue));
    }

    /**
     * Fine all organization states
     */
    async findAllOrganizationStates(requestParameters: FindAllOrganizationStatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllOrganizationStates200Response> {
        const response = await this.findAllOrganizationStatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List active referral recipient configs for accessible sender facilities
     */
    async findAllReferralRecipientConfigsRaw(requestParameters: FindAllReferralRecipientConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllReferralRecipientConfigs200Response>> {
        const queryParameters: any = {};

        if (requestParameters.senderFacilityId !== undefined) {
            queryParameters['sender_facility_id'] = requestParameters.senderFacilityId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/referral-recipient-configs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllReferralRecipientConfigs200ResponseFromJSON(jsonValue));
    }

    /**
     * List active referral recipient configs for accessible sender facilities
     */
    async findAllReferralRecipientConfigs(requestParameters: FindAllReferralRecipientConfigsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllReferralRecipientConfigs200Response> {
        const response = await this.findAllReferralRecipientConfigsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all scheduled screener residents
     * Find all scheduled screener residents
     */
    async findAllScheduledScreenerResidentsRaw(requestParameters: FindAllScheduledScreenerResidentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllScreenerResidents200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling findAllScheduledScreenerResidents.');
        }

        if (requestParameters.scheduledOccupancyType === null || requestParameters.scheduledOccupancyType === undefined) {
            throw new runtime.RequiredError('scheduledOccupancyType','Required parameter requestParameters.scheduledOccupancyType was null or undefined when calling findAllScheduledScreenerResidents.');
        }

        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.startDate !== undefined) {
            queryParameters['start_date'] = (requestParameters.startDate as any).toISOString().substring(0,10);
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['end_date'] = (requestParameters.endDate as any).toISOString().substring(0,10);
        }

        if (requestParameters.scheduledOccupancyType !== undefined) {
            queryParameters['scheduled_occupancy_type'] = requestParameters.scheduledOccupancyType;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.sourceId !== undefined) {
            queryParameters['source_id'] = requestParameters.sourceId;
        }

        if (requestParameters.connector !== undefined) {
            queryParameters['connector'] = requestParameters.connector;
        }

        if (requestParameters.bedTypeId !== undefined) {
            queryParameters['bed_type_id'] = requestParameters.bedTypeId;
        }

        if (requestParameters.includeCancelled !== undefined) {
            queryParameters['include_cancelled'] = requestParameters.includeCancelled;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-residents/scheduled-occupancies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllScreenerResidents200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all scheduled screener residents
     * Find all scheduled screener residents
     */
    async findAllScheduledScreenerResidents(requestParameters: FindAllScheduledScreenerResidentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllScreenerResidents200Response> {
        const response = await this.findAllScheduledScreenerResidentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all screener admission flags
     */
    async findAllScreenerAdmissionFlagsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllScreenerAdmissionFlags200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-admission-flags`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllScreenerAdmissionFlags200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all screener admission flags
     */
    async findAllScreenerAdmissionFlags(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllScreenerAdmissionFlags200Response> {
        const response = await this.findAllScreenerAdmissionFlagsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all screener bed units
     * Find all screener bed units
     */
    async findAllScreenerBedUnitsRaw(requestParameters: FindAllScreenerBedUnitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllScreenerBedUnits200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling findAllScreenerBedUnits.');
        }

        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-bed-units`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllScreenerBedUnits200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all screener bed units
     * Find all screener bed units
     */
    async findAllScreenerBedUnits(requestParameters: FindAllScreenerBedUnitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllScreenerBedUnits200Response> {
        const response = await this.findAllScreenerBedUnitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve screener leads in waitlist
     * Get all leads in waitlist
     */
    async findAllScreenerLeadWaitlistRaw(requestParameters: FindAllScreenerLeadWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllScreenerLeadWaitlist200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling findAllScreenerLeadWaitlist.');
        }

        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.sourceId !== undefined) {
            queryParameters['source_id'] = requestParameters.sourceId;
        }

        if (requestParameters.admissionStatus !== undefined) {
            queryParameters['admission_status'] = requestParameters.admissionStatus;
        }

        if (requestParameters.statusId !== undefined) {
            queryParameters['status_id'] = requestParameters.statusId;
        }

        if (requestParameters.includeEmptyAdmission !== undefined) {
            queryParameters['include_empty_admission'] = requestParameters.includeEmptyAdmission;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/waitlist`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllScreenerLeadWaitlist200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve screener leads in waitlist
     * Get all leads in waitlist
     */
    async findAllScreenerLeadWaitlist(requestParameters: FindAllScreenerLeadWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllScreenerLeadWaitlist200Response> {
        const response = await this.findAllScreenerLeadWaitlistRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve screener residents for a facility
     * Find all screener residents
     */
    async findAllScreenerResidentsRaw(requestParameters: FindAllScreenerResidentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllScreenerResidents200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling findAllScreenerResidents.');
        }

        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.sourceId !== undefined) {
            queryParameters['source_id'] = requestParameters.sourceId;
        }

        if (requestParameters.bedTypeId !== undefined) {
            queryParameters['bed_type_id'] = requestParameters.bedTypeId;
        }

        if (requestParameters.onlyTodayActivity !== undefined) {
            queryParameters['only_today_activity'] = requestParameters.onlyTodayActivity;
        }

        if (requestParameters.stayType !== undefined) {
            queryParameters['stay_type'] = requestParameters.stayType;
        }

        if (requestParameters.payerType !== undefined) {
            queryParameters['payer_type'] = requestParameters.payerType;
        }

        if (requestParameters.payer !== undefined) {
            queryParameters['payer'] = requestParameters.payer;
        }

        if (requestParameters.payerSource !== undefined) {
            queryParameters['payer_source'] = requestParameters.payerSource;
        }

        if (requestParameters.includeNullPayerType !== undefined) {
            queryParameters['include_null_payer_type'] = requestParameters.includeNullPayerType;
        }

        if (requestParameters.includeNullPayerSource !== undefined) {
            queryParameters['include_null_payer_source'] = requestParameters.includeNullPayerSource;
        }

        if (requestParameters.admissionStatus !== undefined) {
            queryParameters['admission_status'] = requestParameters.admissionStatus;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-residents`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllScreenerResidents200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve screener residents for a facility
     * Find all screener residents
     */
    async findAllScreenerResidents(requestParameters: FindAllScreenerResidentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllScreenerResidents200Response> {
        const response = await this.findAllScreenerResidentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all screener tags
     */
    async findAllScreenerTagsRaw(requestParameters: FindAllScreenerTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllScreenerTags200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling findAllScreenerTags.');
        }

        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-tags`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllScreenerTags200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all screener tags
     */
    async findAllScreenerTags(requestParameters: FindAllScreenerTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllScreenerTags200Response> {
        const response = await this.findAllScreenerTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all source allow names for a facility
     * Find all source allow names
     */
    async findAllSourceAllowNamesRaw(requestParameters: FindAllSourceAllowNamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllSourceAllowNames200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling findAllSourceAllowNames.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/source-allow-names/{facility_id}`.replace(`{${"facility_id"}}`, encodeURIComponent(String(requestParameters.facilityId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllSourceAllowNames200ResponseFromJSON(jsonValue));
    }

    /**
     * Find all source allow names for a facility
     * Find all source allow names
     */
    async findAllSourceAllowNames(requestParameters: FindAllSourceAllowNamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllSourceAllowNames200Response> {
        const response = await this.findAllSourceAllowNamesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all screener source tags
     */
    async findAllSourceTagsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllSourceTags200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/source-tags`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllSourceTags200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all screener source tags
     */
    async findAllSourceTags(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllSourceTags200Response> {
        const response = await this.findAllSourceTagsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get exchange facility mappings for multiple facilities
     */
    async findExchangeFacilitiesByFacilityBatchRaw(requestParameters: FindExchangeFacilitiesByFacilityBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindExchangeFacilitiesByFacilityBatch200Response>> {
        if (requestParameters.facilityIds === null || requestParameters.facilityIds === undefined) {
            throw new runtime.RequiredError('facilityIds','Required parameter requestParameters.facilityIds was null or undefined when calling findExchangeFacilitiesByFacilityBatch.');
        }

        const queryParameters: any = {};

        if (requestParameters.facilityIds !== undefined) {
            queryParameters['facility_ids'] = requestParameters.facilityIds;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/exchange-facilities/batch`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindExchangeFacilitiesByFacilityBatch200ResponseFromJSON(jsonValue));
    }

    /**
     * Get exchange facility mappings for multiple facilities
     */
    async findExchangeFacilitiesByFacilityBatch(requestParameters: FindExchangeFacilitiesByFacilityBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindExchangeFacilitiesByFacilityBatch200Response> {
        const response = await this.findExchangeFacilitiesByFacilityBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find eligible and excluded instances for a bulk review stage decision
     */
    async findInstanceBulkDecisionCandidatesRaw(requestParameters: FindInstanceBulkDecisionCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindInstanceBulkDecisionCandidates200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling findInstanceBulkDecisionCandidates.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/bulk-decision-candidates`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindInstanceBulkDecisionCandidates200ResponseFromJSON(jsonValue));
    }

    /**
     * Find eligible and excluded instances for a bulk review stage decision
     */
    async findInstanceBulkDecisionCandidates(requestParameters: FindInstanceBulkDecisionCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindInstanceBulkDecisionCandidates200Response> {
        const response = await this.findInstanceBulkDecisionCandidatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find eligible and excluded instances for a bulk mark as lost
     */
    async findInstanceBulkLostCandidatesRaw(requestParameters: FindInstanceBulkLostCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindInstanceBulkDecisionCandidates200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling findInstanceBulkLostCandidates.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/bulk-lost-candidates`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindInstanceBulkDecisionCandidates200ResponseFromJSON(jsonValue));
    }

    /**
     * Find eligible and excluded instances for a bulk mark as lost
     */
    async findInstanceBulkLostCandidates(requestParameters: FindInstanceBulkLostCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindInstanceBulkDecisionCandidates200Response> {
        const response = await this.findInstanceBulkLostCandidatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a bed by ID
     */
    async findOneBedRaw(requestParameters: FindOneBedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneBed200Response>> {
        if (requestParameters.bedId === null || requestParameters.bedId === undefined) {
            throw new runtime.RequiredError('bedId','Required parameter requestParameters.bedId was null or undefined when calling findOneBed.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/beds/{bed_id}`.replace(`{${"bed_id"}}`, encodeURIComponent(String(requestParameters.bedId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneBed200ResponseFromJSON(jsonValue));
    }

    /**
     * Find a bed by ID
     */
    async findOneBed(requestParameters: FindOneBedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneBed200Response> {
        const response = await this.findOneBedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find One MatrixCare patient\'s details
     */
    async findOneMatrixCarePatientDetailsRaw(requestParameters: FindOneMatrixCarePatientDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneMatrixCarePatientDetails200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling findOneMatrixCarePatientDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/matrix-care/patient/details`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneMatrixCarePatientDetails200ResponseFromJSON(jsonValue));
    }

    /**
     * Find One MatrixCare patient\'s details
     */
    async findOneMatrixCarePatientDetails(requestParameters: FindOneMatrixCarePatientDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneMatrixCarePatientDetails200Response> {
        const response = await this.findOneMatrixCarePatientDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the allowed Dialyze Direct recipient facilities for a given sender SNF facility
     */
    async getAllowedRecipientsRaw(requestParameters: GetAllowedRecipientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllowedRecipients200Response>> {
        if (requestParameters.senderFacilityId === null || requestParameters.senderFacilityId === undefined) {
            throw new runtime.RequiredError('senderFacilityId','Required parameter requestParameters.senderFacilityId was null or undefined when calling getAllowedRecipients.');
        }

        const queryParameters: any = {};

        if (requestParameters.senderFacilityId !== undefined) {
            queryParameters['sender_facility_id'] = requestParameters.senderFacilityId;
        }

        if (requestParameters.referralType !== undefined) {
            queryParameters['referral_type'] = requestParameters.referralType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/referrals/allowed-recipients`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAllowedRecipients200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the allowed Dialyze Direct recipient facilities for a given sender SNF facility
     */
    async getAllowedRecipients(requestParameters: GetAllowedRecipientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllowedRecipients200Response> {
        const response = await this.getAllowedRecipientsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the override history for a specific analysis result
     * Get analysis result override history
     */
    async getAnalysisResultHistoryRaw(requestParameters: GetAnalysisResultHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAnalysisResultHistory200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling getAnalysisResultHistory.');
        }

        if (requestParameters.resultId === null || requestParameters.resultId === undefined) {
            throw new runtime.RequiredError('resultId','Required parameter requestParameters.resultId was null or undefined when calling getAnalysisResultHistory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/analysis-results/{result_id}/history`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))).replace(`{${"result_id"}}`, encodeURIComponent(String(requestParameters.resultId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAnalysisResultHistory200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve the override history for a specific analysis result
     * Get analysis result override history
     */
    async getAnalysisResultHistory(requestParameters: GetAnalysisResultHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAnalysisResultHistory200Response> {
        const response = await this.getAnalysisResultHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve document exclusion terms for a facility
     * Get document exclusion terms
     */
    async getDocumentExclusionTermsRaw(requestParameters: GetDocumentExclusionTermsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDocumentExclusionTerms200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling getDocumentExclusionTerms.');
        }

        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/document-exclusion-terms`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDocumentExclusionTerms200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve document exclusion terms for a facility
     * Get document exclusion terms
     */
    async getDocumentExclusionTerms(requestParameters: GetDocumentExclusionTermsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDocumentExclusionTerms200Response> {
        const response = await this.getDocumentExclusionTermsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve facility bed occupancy stats
     * Get facility bed occupancy stats
     */
    async getFacilityBedOccupancyStatsRaw(requestParameters: GetFacilityBedOccupancyStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFacilityBedOccupancyStats200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling getFacilityBedOccupancyStats.');
        }

        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-residents/stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFacilityBedOccupancyStats200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve facility bed occupancy stats
     * Get facility bed occupancy stats
     */
    async getFacilityBedOccupancyStats(requestParameters: GetFacilityBedOccupancyStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFacilityBedOccupancyStats200Response> {
        const response = await this.getFacilityBedOccupancyStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve unpaid invoice statuses for a facility including organization-level payers
     * Get unpaid invoice statuses
     */
    async getFacilityInvoiceStatusesRaw(requestParameters: GetFacilityInvoiceStatusesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFacilityInvoiceStatuses200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling getFacilityInvoiceStatuses.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/facilities/{facility_id}/invoice-statuses`.replace(`{${"facility_id"}}`, encodeURIComponent(String(requestParameters.facilityId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFacilityInvoiceStatuses200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve unpaid invoice statuses for a facility including organization-level payers
     * Get unpaid invoice statuses
     */
    async getFacilityInvoiceStatuses(requestParameters: GetFacilityInvoiceStatusesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFacilityInvoiceStatuses200Response> {
        const response = await this.getFacilityInvoiceStatusesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all FE-readable screener settings (resolved via facility > org > default hierarchy) for the provided facility IDs.
     * Get FE-readable screener settings for multiple facilities
     */
    async getFacilityScreenerSettingsRaw(requestParameters: GetFacilityScreenerSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFacilityScreenerSettings200Response>> {
        if (requestParameters.facilityIds === null || requestParameters.facilityIds === undefined) {
            throw new runtime.RequiredError('facilityIds','Required parameter requestParameters.facilityIds was null or undefined when calling getFacilityScreenerSettings.');
        }

        const queryParameters: any = {};

        if (requestParameters.facilityIds !== undefined) {
            queryParameters['facility_ids'] = requestParameters.facilityIds;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/facility-screener-settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFacilityScreenerSettings200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all FE-readable screener settings (resolved via facility > org > default hierarchy) for the provided facility IDs.
     * Get FE-readable screener settings for multiple facilities
     */
    async getFacilityScreenerSettings(requestParameters: GetFacilityScreenerSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFacilityScreenerSettings200Response> {
        const response = await this.getFacilityScreenerSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get generated ICD-10 diagnoses for a lead
     */
    async getLeadDiagnosesRaw(requestParameters: GetLeadDiagnosesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeadDiagnoses200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling getLeadDiagnoses.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-leads/{lead_id}/diagnoses`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeadDiagnoses200ResponseFromJSON(jsonValue));
    }

    /**
     * Get generated ICD-10 diagnoses for a lead
     */
    async getLeadDiagnoses(requestParameters: GetLeadDiagnosesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeadDiagnoses200Response> {
        const response = await this.getLeadDiagnosesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the latest `shadow_admission_decisions` row for the lead as-is. The FE is responsible for mapping the 5 backend subsystems (clinical / financial / safety / administrative / occupancy) onto its 4 UI sub-tabs (Admission Package / Insurance / Background / Bed Availability). 
     * Get the latest shadow admission decision for a lead
     */
    async getLeadShadowDecisionRaw(requestParameters: GetLeadShadowDecisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeadShadowDecision200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling getLeadShadowDecision.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/shadow-decision`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeadShadowDecision200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns the latest `shadow_admission_decisions` row for the lead as-is. The FE is responsible for mapping the 5 backend subsystems (clinical / financial / safety / administrative / occupancy) onto its 4 UI sub-tabs (Admission Package / Insurance / Background / Bed Availability). 
     * Get the latest shadow admission decision for a lead
     */
    async getLeadShadowDecision(requestParameters: GetLeadShadowDecisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeadShadowDecision200Response> {
        const response = await this.getLeadShadowDecisionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns per-cell lead counts over the same filter set as FindAllLeads, but without the status_id / admission_status constraints (those dimensions are the grouping keys, not filters). Counts individual leads (not duplicate groups). Cancelled leads are always excluded.
     * Get screener lead counts grouped by review stage and admission status
     */
    async getLeadStageCountsRaw(requestParameters: GetLeadStageCountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLeadStageCounts200Response>> {
        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        if (requestParameters.sourceId !== undefined) {
            queryParameters['source_id'] = requestParameters.sourceId;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.suggestion !== undefined) {
            queryParameters['suggestion'] = requestParameters.suggestion;
        }

        if (requestParameters.connector !== undefined) {
            queryParameters['connector'] = requestParameters.connector;
        }

        if (requestParameters.payerType !== undefined) {
            queryParameters['payer_type'] = requestParameters.payerType;
        }

        if (requestParameters.payer !== undefined) {
            queryParameters['payer'] = requestParameters.payer;
        }

        if (requestParameters.payerSource !== undefined) {
            queryParameters['payer_source'] = requestParameters.payerSource;
        }

        if (requestParameters.includeNullPayerType !== undefined) {
            queryParameters['include_null_payer_type'] = requestParameters.includeNullPayerType;
        }

        if (requestParameters.includeNullPayerSource !== undefined) {
            queryParameters['include_null_payer_source'] = requestParameters.includeNullPayerSource;
        }

        if (requestParameters.pccStatus !== undefined) {
            queryParameters['pcc_status'] = requestParameters.pccStatus;
        }

        if (requestParameters.matrixCareStatus !== undefined) {
            queryParameters['matrix_care_status'] = requestParameters.matrixCareStatus;
        }

        if (requestParameters.hasNewHospitalMessages !== undefined) {
            queryParameters['has_new_hospital_messages'] = requestParameters.hasNewHospitalMessages;
        }

        if (requestParameters.hasNewDocuments !== undefined) {
            queryParameters['has_new_documents'] = requestParameters.hasNewDocuments;
        }

        if (requestParameters.assigneeUserIds !== undefined) {
            queryParameters['assignee_user_ids'] = requestParameters.assigneeUserIds;
        }

        if (requestParameters.unassigned !== undefined) {
            queryParameters['unassigned'] = requestParameters.unassigned;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/kanban-stage-counts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLeadStageCounts200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns per-cell lead counts over the same filter set as FindAllLeads, but without the status_id / admission_status constraints (those dimensions are the grouping keys, not filters). Counts individual leads (not duplicate groups). Cancelled leads are always excluded.
     * Get screener lead counts grouped by review stage and admission status
     */
    async getLeadStageCounts(requestParameters: GetLeadStageCountsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLeadStageCounts200Response> {
        const response = await this.getLeadStageCountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve individual facility setting value
     * Get facility setting value
     */
    async getOneFacilitySettingRaw(requestParameters: GetOneFacilitySettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOneFacilitySetting200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling getOneFacilitySetting.');
        }

        if (requestParameters.settingName === null || requestParameters.settingName === undefined) {
            throw new runtime.RequiredError('settingName','Required parameter requestParameters.settingName was null or undefined when calling getOneFacilitySetting.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/facilities/{facility_id}/settings/{setting_name}`.replace(`{${"facility_id"}}`, encodeURIComponent(String(requestParameters.facilityId))).replace(`{${"setting_name"}}`, encodeURIComponent(String(requestParameters.settingName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOneFacilitySetting200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve individual facility setting value
     * Get facility setting value
     */
    async getOneFacilitySetting(requestParameters: GetOneFacilitySettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOneFacilitySetting200Response> {
        const response = await this.getOneFacilitySettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a screener setting for an organization
     * Get a screener setting
     */
    async getScreenerSettingRaw(requestParameters: GetScreenerSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetScreenerSetting200Response>> {
        if (requestParameters.settingName === null || requestParameters.settingName === undefined) {
            throw new runtime.RequiredError('settingName','Required parameter requestParameters.settingName was null or undefined when calling getScreenerSetting.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/screener-settings/{setting_name}`.replace(`{${"setting_name"}}`, encodeURIComponent(String(requestParameters.settingName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetScreenerSetting200ResponseFromJSON(jsonValue));
    }

    /**
     * Get a screener setting for an organization
     * Get a screener setting
     */
    async getScreenerSetting(requestParameters: GetScreenerSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetScreenerSetting200Response> {
        const response = await this.getScreenerSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the count of unread faxes for a facility or all accessible facilities
     */
    async getUnreadFaxCountRaw(requestParameters: GetUnreadFaxCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUnreadFaxCount200Response>> {
        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        if (requestParameters.facilityType !== undefined) {
            queryParameters['facility_type'] = requestParameters.facilityType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/efax/unread-count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUnreadFaxCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the count of unread faxes for a facility or all accessible facilities
     */
    async getUnreadFaxCount(requestParameters: GetUnreadFaxCountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUnreadFaxCount200Response> {
        const response = await this.getUnreadFaxCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Link a fax document to an existing referral
     */
    async linkFaxToReferralRaw(requestParameters: LinkFaxToReferralOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling linkFaxToReferral.');
        }

        if (requestParameters.linkFaxToReferralRequest === null || requestParameters.linkFaxToReferralRequest === undefined) {
            throw new runtime.RequiredError('linkFaxToReferralRequest','Required parameter requestParameters.linkFaxToReferralRequest was null or undefined when calling linkFaxToReferral.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/efax/faxes/{id}/link-to-referral`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LinkFaxToReferralRequestToJSON(requestParameters.linkFaxToReferralRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Link a fax document to an existing referral
     */
    async linkFaxToReferral(requestParameters: LinkFaxToReferralOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.linkFaxToReferralRaw(requestParameters, initOverrides);
    }

    /**
     * Override the criteria result of an analysis result with a new value and reason
     * Override an analysis result
     */
    async overrideAnalysisResultRaw(requestParameters: OverrideAnalysisResultOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OverrideAnalysisResult200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling overrideAnalysisResult.');
        }

        if (requestParameters.resultId === null || requestParameters.resultId === undefined) {
            throw new runtime.RequiredError('resultId','Required parameter requestParameters.resultId was null or undefined when calling overrideAnalysisResult.');
        }

        if (requestParameters.overrideAnalysisResultRequest === null || requestParameters.overrideAnalysisResultRequest === undefined) {
            throw new runtime.RequiredError('overrideAnalysisResultRequest','Required parameter requestParameters.overrideAnalysisResultRequest was null or undefined when calling overrideAnalysisResult.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/analysis-results/{result_id}/override`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))).replace(`{${"result_id"}}`, encodeURIComponent(String(requestParameters.resultId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OverrideAnalysisResultRequestToJSON(requestParameters.overrideAnalysisResultRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OverrideAnalysisResult200ResponseFromJSON(jsonValue));
    }

    /**
     * Override the criteria result of an analysis result with a new value and reason
     * Override an analysis result
     */
    async overrideAnalysisResult(requestParameters: OverrideAnalysisResultOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OverrideAnalysisResult200Response> {
        const response = await this.overrideAnalysisResultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Combines multiple PDF documents and returns a signed URL for download
     * Download combined PDF documents
     */
    async pdfDownloaderRaw(requestParameters: PdfDownloaderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PdfDownloader200Response>> {
        if (requestParameters.documentIds === null || requestParameters.documentIds === undefined) {
            throw new runtime.RequiredError('documentIds','Required parameter requestParameters.documentIds was null or undefined when calling pdfDownloader.');
        }

        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling pdfDownloader.');
        }

        const queryParameters: any = {};

        if (requestParameters.documentIds !== undefined) {
            queryParameters['document_ids'] = requestParameters.documentIds;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/documents-download`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PdfDownloader200ResponseFromJSON(jsonValue));
    }

    /**
     * Combines multiple PDF documents and returns a signed URL for download
     * Download combined PDF documents
     */
    async pdfDownloader(requestParameters: PdfDownloaderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PdfDownloader200Response> {
        const response = await this.pdfDownloaderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Process an integration event
     */
    async processIntegrationEventRaw(requestParameters: ProcessIntegrationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.integrationEventId === null || requestParameters.integrationEventId === undefined) {
            throw new runtime.RequiredError('integrationEventId','Required parameter requestParameters.integrationEventId was null or undefined when calling processIntegrationEvent.');
        }

        if (requestParameters.action === null || requestParameters.action === undefined) {
            throw new runtime.RequiredError('action','Required parameter requestParameters.action was null or undefined when calling processIntegrationEvent.');
        }

        const queryParameters: any = {};

        if (requestParameters.action !== undefined) {
            queryParameters['action'] = requestParameters.action;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/integration-events/action/{integration_event_id}`.replace(`{${"integration_event_id"}}`, encodeURIComponent(String(requestParameters.integrationEventId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Process an integration event
     */
    async processIntegrationEvent(requestParameters: ProcessIntegrationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.processIntegrationEventRaw(requestParameters, initOverrides);
    }

    /**
     * Relocate a screener resident to a new bed
     * Relocate screener resident
     */
    async relocateScreenerResidentRaw(requestParameters: RelocateScreenerResidentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelocateScreenerResident200Response>> {
        if (requestParameters.residentId === null || requestParameters.residentId === undefined) {
            throw new runtime.RequiredError('residentId','Required parameter requestParameters.residentId was null or undefined when calling relocateScreenerResident.');
        }

        if (requestParameters.relocateScreenerResidentRequest === null || requestParameters.relocateScreenerResidentRequest === undefined) {
            throw new runtime.RequiredError('relocateScreenerResidentRequest','Required parameter requestParameters.relocateScreenerResidentRequest was null or undefined when calling relocateScreenerResident.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/screener-residents/{resident_id}/relocate`.replace(`{${"resident_id"}}`, encodeURIComponent(String(requestParameters.residentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RelocateScreenerResidentRequestToJSON(requestParameters.relocateScreenerResidentRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RelocateScreenerResident200ResponseFromJSON(jsonValue));
    }

    /**
     * Relocate a screener resident to a new bed
     * Relocate screener resident
     */
    async relocateScreenerResident(requestParameters: RelocateScreenerResidentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelocateScreenerResident200Response> {
        const response = await this.relocateScreenerResidentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reset PCC E2E fixture state for a lead
     */
    async resetPccE2eFixtureRaw(requestParameters: ResetPccE2eFixtureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResetPccE2eFixture200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling resetPccE2eFixture.');
        }

        if (requestParameters.pccE2eFixtureResetRequest === null || requestParameters.pccE2eFixtureResetRequest === undefined) {
            throw new runtime.RequiredError('pccE2eFixtureResetRequest','Required parameter requestParameters.pccE2eFixtureResetRequest was null or undefined when calling resetPccE2eFixture.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/pcc/e2e-fixtures/reset`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PccE2eFixtureResetRequestToJSON(requestParameters.pccE2eFixtureResetRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResetPccE2eFixture200ResponseFromJSON(jsonValue));
    }

    /**
     * Reset PCC E2E fixture state for a lead
     */
    async resetPccE2eFixture(requestParameters: ResetPccE2eFixtureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResetPccE2eFixture200Response> {
        const response = await this.resetPccE2eFixtureRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reset PCC push status for a lead
     */
    async resetPccPushStatusRaw(requestParameters: ResetPccPushStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResetPccPushStatus200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling resetPccPushStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/pcc/push-status/reset`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResetPccPushStatus200ResponseFromJSON(jsonValue));
    }

    /**
     * Reset PCC push status for a lead
     */
    async resetPccPushStatus(requestParameters: ResetPccPushStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResetPccPushStatus200Response> {
        const response = await this.resetPccPushStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Revert a previous override of an analysis result
     * Revert an analysis result override
     */
    async revertAnalysisResultRaw(requestParameters: RevertAnalysisResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OverrideAnalysisResult200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling revertAnalysisResult.');
        }

        if (requestParameters.resultId === null || requestParameters.resultId === undefined) {
            throw new runtime.RequiredError('resultId','Required parameter requestParameters.resultId was null or undefined when calling revertAnalysisResult.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/analysis-results/{result_id}/revert`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))).replace(`{${"result_id"}}`, encodeURIComponent(String(requestParameters.resultId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OverrideAnalysisResult200ResponseFromJSON(jsonValue));
    }

    /**
     * Revert a previous override of an analysis result
     * Revert an analysis result override
     */
    async revertAnalysisResult(requestParameters: RevertAnalysisResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OverrideAnalysisResult200Response> {
        const response = await this.revertAnalysisResultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fuzzy name search over provider_directory, filtered by provider type and location.
     * Search the global provider directory by name
     */
    async searchProviderDirectoryRaw(requestParameters: SearchProviderDirectoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchProviderDirectory200Response>> {
        if (requestParameters.q === null || requestParameters.q === undefined) {
            throw new runtime.RequiredError('q','Required parameter requestParameters.q was null or undefined when calling searchProviderDirectory.');
        }

        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling searchProviderDirectory.');
        }

        const queryParameters: any = {};

        if (requestParameters.q !== undefined) {
            queryParameters['q'] = requestParameters.q;
        }

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        if (requestParameters.providerType !== undefined) {
            queryParameters['provider_type'] = requestParameters.providerType;
        }

        if (requestParameters.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }

        if (requestParameters.zip !== undefined) {
            queryParameters['zip'] = requestParameters.zip;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/provider-directory/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchProviderDirectory200ResponseFromJSON(jsonValue));
    }

    /**
     * Fuzzy name search over provider_directory, filtered by provider type and location.
     * Search the global provider directory by name
     */
    async searchProviderDirectory(requestParameters: SearchProviderDirectoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchProviderDirectory200Response> {
        const response = await this.searchProviderDirectoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send an outbound referral for a lead
     */
    async sendLeadReferralRaw(requestParameters: SendLeadReferralOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendLeadReferral201Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling sendLeadReferral.');
        }

        if (requestParameters.sendLeadReferralRequest === null || requestParameters.sendLeadReferralRequest === undefined) {
            throw new runtime.RequiredError('sendLeadReferralRequest','Required parameter requestParameters.sendLeadReferralRequest was null or undefined when calling sendLeadReferral.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/referrals/send`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendLeadReferralRequestToJSON(requestParameters.sendLeadReferralRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SendLeadReferral201ResponseFromJSON(jsonValue));
    }

    /**
     * Send an outbound referral for a lead
     */
    async sendLeadReferral(requestParameters: SendLeadReferralOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendLeadReferral201Response> {
        const response = await this.sendLeadReferralRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Swap the residents between two beds
     * Swap residents between two beds
     */
    async swapScreenerLeadResidentsRaw(requestParameters: SwapScreenerLeadResidentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SwapScreenerLeadResidents200Response>> {
        if (requestParameters.swapScreenerLeadResidentsRequest === null || requestParameters.swapScreenerLeadResidentsRequest === undefined) {
            throw new runtime.RequiredError('swapScreenerLeadResidentsRequest','Required parameter requestParameters.swapScreenerLeadResidentsRequest was null or undefined when calling swapScreenerLeadResidents.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/screener-leads/swap-residents`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SwapScreenerLeadResidentsRequestToJSON(requestParameters.swapScreenerLeadResidentsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SwapScreenerLeadResidents200ResponseFromJSON(jsonValue));
    }

    /**
     * Swap the residents between two beds
     * Swap residents between two beds
     */
    async swapScreenerLeadResidents(requestParameters: SwapScreenerLeadResidentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SwapScreenerLeadResidents200Response> {
        const response = await this.swapScreenerLeadResidentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Switch the town between served/unserved organization state where it belongs
     */
    async switchOrganizationStateTownTypeRaw(requestParameters: SwitchOrganizationStateTownTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling switchOrganizationStateTownType.');
        }

        if (requestParameters.organizationStateTownSwitchTypeRequest === null || requestParameters.organizationStateTownSwitchTypeRequest === undefined) {
            throw new runtime.RequiredError('organizationStateTownSwitchTypeRequest','Required parameter requestParameters.organizationStateTownSwitchTypeRequest was null or undefined when calling switchOrganizationStateTownType.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/organization-state-towns/{id}/switch-type`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationStateTownSwitchTypeRequestToJSON(requestParameters.organizationStateTownSwitchTypeRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Switch the town between served/unserved organization state where it belongs
     */
    async switchOrganizationStateTownType(requestParameters: SwitchOrganizationStateTownTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.switchOrganizationStateTownTypeRaw(requestParameters, initOverrides);
    }

    /**
     * Trigger the Pdpm Estimator for a lead
     * Trigger Pdpm Estimator
     */
    async triggerPdpmEstimatorRaw(requestParameters: TriggerPdpmEstimatorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling triggerPdpmEstimator.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/trigger-pdpm-estimator`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Trigger the Pdpm Estimator for a lead
     * Trigger Pdpm Estimator
     */
    async triggerPdpmEstimator(requestParameters: TriggerPdpmEstimatorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.triggerPdpmEstimatorRaw(requestParameters, initOverrides);
    }

    /**
     * Update the note for a specific bed
     * Update a bed\'s note
     */
    async updateBedNoteRaw(requestParameters: UpdateBedNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneBed200Response>> {
        if (requestParameters.bedId === null || requestParameters.bedId === undefined) {
            throw new runtime.RequiredError('bedId','Required parameter requestParameters.bedId was null or undefined when calling updateBedNote.');
        }

        if (requestParameters.updateBedNoteRequest === null || requestParameters.updateBedNoteRequest === undefined) {
            throw new runtime.RequiredError('updateBedNoteRequest','Required parameter requestParameters.updateBedNoteRequest was null or undefined when calling updateBedNote.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/beds/{bed_id}/note`.replace(`{${"bed_id"}}`, encodeURIComponent(String(requestParameters.bedId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBedNoteRequestToJSON(requestParameters.updateBedNoteRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneBed200ResponseFromJSON(jsonValue));
    }

    /**
     * Update the note for a specific bed
     * Update a bed\'s note
     */
    async updateBedNote(requestParameters: UpdateBedNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneBed200Response> {
        const response = await this.updateBedNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a screener criteria
     */
    async updateCriteriaRaw(requestParameters: UpdateCriteriaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateGlobalCriteria201Response>> {
        if (requestParameters.criteriaId === null || requestParameters.criteriaId === undefined) {
            throw new runtime.RequiredError('criteriaId','Required parameter requestParameters.criteriaId was null or undefined when calling updateCriteria.');
        }

        if (requestParameters.criteria === null || requestParameters.criteria === undefined) {
            throw new runtime.RequiredError('criteria','Required parameter requestParameters.criteria was null or undefined when calling updateCriteria.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/criteria/{criteria_id}`.replace(`{${"criteria_id"}}`, encodeURIComponent(String(requestParameters.criteriaId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CriteriaToJSON(requestParameters.criteria),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateGlobalCriteria201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a screener criteria
     */
    async updateCriteria(requestParameters: UpdateCriteriaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateGlobalCriteria201Response> {
        const response = await this.updateCriteriaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update criteria categories
     * Update criteria categories
     */
    async updateCriteriaCategoriesRaw(requestParameters: UpdateCriteriaCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllCriteriaCategories200Response>> {
        if (requestParameters.bulkUpdateCriteriaCategoriesRequest === null || requestParameters.bulkUpdateCriteriaCategoriesRequest === undefined) {
            throw new runtime.RequiredError('bulkUpdateCriteriaCategoriesRequest','Required parameter requestParameters.bulkUpdateCriteriaCategoriesRequest was null or undefined when calling updateCriteriaCategories.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/criteria/categories`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateCriteriaCategoriesRequestToJSON(requestParameters.bulkUpdateCriteriaCategoriesRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllCriteriaCategories200ResponseFromJSON(jsonValue));
    }

    /**
     * Update criteria categories
     * Update criteria categories
     */
    async updateCriteriaCategories(requestParameters: UpdateCriteriaCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllCriteriaCategories200Response> {
        const response = await this.updateCriteriaCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a screener criteria in place and replace all of its targets in a single transaction
     * Update a criteria and replace its targets
     */
    async updateCriteriaTargetsRaw(requestParameters: UpdateCriteriaTargetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateCriteriaTargets201Response>> {
        if (requestParameters.criteriaId === null || requestParameters.criteriaId === undefined) {
            throw new runtime.RequiredError('criteriaId','Required parameter requestParameters.criteriaId was null or undefined when calling updateCriteriaTargets.');
        }

        if (requestParameters.createCriteriaTargetsRequest === null || requestParameters.createCriteriaTargetsRequest === undefined) {
            throw new runtime.RequiredError('createCriteriaTargetsRequest','Required parameter requestParameters.createCriteriaTargetsRequest was null or undefined when calling updateCriteriaTargets.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/criteria/targets/{criteria_id}`.replace(`{${"criteria_id"}}`, encodeURIComponent(String(requestParameters.criteriaId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCriteriaTargetsRequestToJSON(requestParameters.createCriteriaTargetsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCriteriaTargets201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a screener criteria in place and replace all of its targets in a single transaction
     * Update a criteria and replace its targets
     */
    async updateCriteriaTargets(requestParameters: UpdateCriteriaTargetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateCriteriaTargets201Response> {
        const response = await this.updateCriteriaTargetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing document exclusion term
     * Update document exclusion term
     */
    async updateDocumentExclusionTermRaw(requestParameters: UpdateDocumentExclusionTermOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateDocumentExclusionTerm201Response>> {
        if (requestParameters.termId === null || requestParameters.termId === undefined) {
            throw new runtime.RequiredError('termId','Required parameter requestParameters.termId was null or undefined when calling updateDocumentExclusionTerm.');
        }

        if (requestParameters.updateDocumentExclusionTermRequest === null || requestParameters.updateDocumentExclusionTermRequest === undefined) {
            throw new runtime.RequiredError('updateDocumentExclusionTermRequest','Required parameter requestParameters.updateDocumentExclusionTermRequest was null or undefined when calling updateDocumentExclusionTerm.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/document-exclusion-terms/{term_id}`.replace(`{${"term_id"}}`, encodeURIComponent(String(requestParameters.termId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDocumentExclusionTermRequestToJSON(requestParameters.updateDocumentExclusionTermRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateDocumentExclusionTerm201ResponseFromJSON(jsonValue));
    }

    /**
     * Update an existing document exclusion term
     * Update document exclusion term
     */
    async updateDocumentExclusionTerm(requestParameters: UpdateDocumentExclusionTermOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateDocumentExclusionTerm201Response> {
        const response = await this.updateDocumentExclusionTermRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Rename a facility region and reconcile its assigned facilities
     */
    async updateFacilityRegionRaw(requestParameters: UpdateFacilityRegionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFacilityRegion201Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateFacilityRegion.');
        }

        if (requestParameters.updateFacilityRegionRequest === null || requestParameters.updateFacilityRegionRequest === undefined) {
            throw new runtime.RequiredError('updateFacilityRegionRequest','Required parameter requestParameters.updateFacilityRegionRequest was null or undefined when calling updateFacilityRegion.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/facility-regions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFacilityRegionRequestToJSON(requestParameters.updateFacilityRegionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFacilityRegion201ResponseFromJSON(jsonValue));
    }

    /**
     * Rename a facility region and reconcile its assigned facilities
     */
    async updateFacilityRegion(requestParameters: UpdateFacilityRegionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFacilityRegion201Response> {
        const response = await this.updateFacilityRegionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a service area entry for a facility
     */
    async updateFacilityServiceAreaRaw(requestParameters: UpdateFacilityServiceAreaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFacilityServiceArea201Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling updateFacilityServiceArea.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateFacilityServiceArea.');
        }

        if (requestParameters.updateFacilityServiceAreaRequest === null || requestParameters.updateFacilityServiceAreaRequest === undefined) {
            throw new runtime.RequiredError('updateFacilityServiceAreaRequest','Required parameter requestParameters.updateFacilityServiceAreaRequest was null or undefined when calling updateFacilityServiceArea.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/facilities/{facility_id}/service-areas/{id}`.replace(`{${"facility_id"}}`, encodeURIComponent(String(requestParameters.facilityId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFacilityServiceAreaRequestToJSON(requestParameters.updateFacilityServiceAreaRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFacilityServiceArea201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a service area entry for a facility
     */
    async updateFacilityServiceArea(requestParameters: UpdateFacilityServiceAreaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFacilityServiceArea201Response> {
        const response = await this.updateFacilityServiceAreaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a screener setting for a specific facility
     * Update a facility setting
     */
    async updateFacilitySettingRaw(requestParameters: UpdateFacilitySettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling updateFacilitySetting.');
        }

        if (requestParameters.settingName === null || requestParameters.settingName === undefined) {
            throw new runtime.RequiredError('settingName','Required parameter requestParameters.settingName was null or undefined when calling updateFacilitySetting.');
        }

        if (requestParameters.updateScreenerSettingRequest === null || requestParameters.updateScreenerSettingRequest === undefined) {
            throw new runtime.RequiredError('updateScreenerSettingRequest','Required parameter requestParameters.updateScreenerSettingRequest was null or undefined when calling updateFacilitySetting.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/facilities/{facility_id}/settings/{setting_name}`.replace(`{${"facility_id"}}`, encodeURIComponent(String(requestParameters.facilityId))).replace(`{${"setting_name"}}`, encodeURIComponent(String(requestParameters.settingName))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateScreenerSettingRequestToJSON(requestParameters.updateScreenerSettingRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a screener setting for a specific facility
     * Update a facility setting
     */
    async updateFacilitySetting(requestParameters: UpdateFacilitySettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateFacilitySettingRaw(requestParameters, initOverrides);
    }

    /**
     * Update fax read status
     */
    async updateFaxReadStatusRaw(requestParameters: UpdateFaxReadStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateFaxReadStatus.');
        }

        if (requestParameters.updateFaxReadStatusRequest === null || requestParameters.updateFaxReadStatusRequest === undefined) {
            throw new runtime.RequiredError('updateFaxReadStatusRequest','Required parameter requestParameters.updateFaxReadStatusRequest was null or undefined when calling updateFaxReadStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/efax/faxes/{id}/read-status`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFaxReadStatusRequestToJSON(requestParameters.updateFaxReadStatusRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update fax read status
     */
    async updateFaxReadStatus(requestParameters: UpdateFaxReadStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateFaxReadStatusRaw(requestParameters, initOverrides);
    }

    /**
     * Update a filter view
     */
    async updateFilterViewByIdRaw(requestParameters: UpdateFilterViewByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFilterView201Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateFilterViewById.');
        }

        if (requestParameters.updateFilterViewRequest === null || requestParameters.updateFilterViewRequest === undefined) {
            throw new runtime.RequiredError('updateFilterViewRequest','Required parameter requestParameters.updateFilterViewRequest was null or undefined when calling updateFilterViewById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/filter-views/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFilterViewRequestToJSON(requestParameters.updateFilterViewRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFilterView201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a filter view
     */
    async updateFilterViewById(requestParameters: UpdateFilterViewByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFilterView201Response> {
        const response = await this.updateFilterViewByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a screener lead info
     * Update a screener lead info
     */
    async updateLeadInfoRaw(requestParameters: UpdateLeadInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLeadInfo201Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling updateLeadInfo.');
        }

        if (requestParameters.createLeadInfoRequest === null || requestParameters.createLeadInfoRequest === undefined) {
            throw new runtime.RequiredError('createLeadInfoRequest','Required parameter requestParameters.createLeadInfoRequest was null or undefined when calling updateLeadInfo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/lead-info/{lead_id}`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLeadInfoRequestToJSON(requestParameters.createLeadInfoRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLeadInfo201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a screener lead info
     * Update a screener lead info
     */
    async updateLeadInfo(requestParameters: UpdateLeadInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLeadInfo201Response> {
        const response = await this.updateLeadInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a lead waitlist record
     */
    async updateLeadWaitlistRaw(requestParameters: UpdateLeadWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLeadWaitlistStatus200Response>> {
        if (requestParameters.waitlistId === null || requestParameters.waitlistId === undefined) {
            throw new runtime.RequiredError('waitlistId','Required parameter requestParameters.waitlistId was null or undefined when calling updateLeadWaitlist.');
        }

        if (requestParameters.findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist === null || requestParameters.findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist === undefined) {
            throw new runtime.RequiredError('findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist','Required parameter requestParameters.findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist was null or undefined when calling updateLeadWaitlist.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/lead-waitlist/{waitlist_id}`.replace(`{${"waitlist_id"}}`, encodeURIComponent(String(requestParameters.waitlistId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistToJSON(requestParameters.findAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateLeadWaitlistStatus200ResponseFromJSON(jsonValue));
    }

    /**
     * Update a lead waitlist record
     */
    async updateLeadWaitlist(requestParameters: UpdateLeadWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLeadWaitlistStatus200Response> {
        const response = await this.updateLeadWaitlistRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the rank of a lead waitlist record
     */
    async updateLeadWaitlistRankRaw(requestParameters: UpdateLeadWaitlistRankOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLeadWaitlistStatus200Response>> {
        if (requestParameters.waitlistId === null || requestParameters.waitlistId === undefined) {
            throw new runtime.RequiredError('waitlistId','Required parameter requestParameters.waitlistId was null or undefined when calling updateLeadWaitlistRank.');
        }

        if (requestParameters.updateLeadWaitlistRankRequest === null || requestParameters.updateLeadWaitlistRankRequest === undefined) {
            throw new runtime.RequiredError('updateLeadWaitlistRankRequest','Required parameter requestParameters.updateLeadWaitlistRankRequest was null or undefined when calling updateLeadWaitlistRank.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/lead-waitlist/{waitlist_id}/rank`.replace(`{${"waitlist_id"}}`, encodeURIComponent(String(requestParameters.waitlistId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLeadWaitlistRankRequestToJSON(requestParameters.updateLeadWaitlistRankRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateLeadWaitlistStatus200ResponseFromJSON(jsonValue));
    }

    /**
     * Updates the rank of a lead waitlist record
     */
    async updateLeadWaitlistRank(requestParameters: UpdateLeadWaitlistRankOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLeadWaitlistStatus200Response> {
        const response = await this.updateLeadWaitlistRankRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a lead waitlist status
     */
    async updateLeadWaitlistStatusRaw(requestParameters: UpdateLeadWaitlistStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLeadWaitlistStatus200Response>> {
        if (requestParameters.waitlistId === null || requestParameters.waitlistId === undefined) {
            throw new runtime.RequiredError('waitlistId','Required parameter requestParameters.waitlistId was null or undefined when calling updateLeadWaitlistStatus.');
        }

        if (requestParameters.updateLeadWaitlistStatusRequest === null || requestParameters.updateLeadWaitlistStatusRequest === undefined) {
            throw new runtime.RequiredError('updateLeadWaitlistStatusRequest','Required parameter requestParameters.updateLeadWaitlistStatusRequest was null or undefined when calling updateLeadWaitlistStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/lead-waitlist/{waitlist_id}/status`.replace(`{${"waitlist_id"}}`, encodeURIComponent(String(requestParameters.waitlistId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLeadWaitlistStatusRequestToJSON(requestParameters.updateLeadWaitlistStatusRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateLeadWaitlistStatus200ResponseFromJSON(jsonValue));
    }

    /**
     * Update a lead waitlist status
     */
    async updateLeadWaitlistStatus(requestParameters: UpdateLeadWaitlistStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLeadWaitlistStatus200Response> {
        const response = await this.updateLeadWaitlistStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a referral recipient config
     */
    async updateReferralRecipientConfigRaw(requestParameters: UpdateReferralRecipientConfigOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateReferralRecipientConfig201Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateReferralRecipientConfig.');
        }

        if (requestParameters.updateReferralRecipientConfigRequest === null || requestParameters.updateReferralRecipientConfigRequest === undefined) {
            throw new runtime.RequiredError('updateReferralRecipientConfigRequest','Required parameter requestParameters.updateReferralRecipientConfigRequest was null or undefined when calling updateReferralRecipientConfig.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/referral-recipient-configs/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReferralRecipientConfigRequestToJSON(requestParameters.updateReferralRecipientConfigRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateReferralRecipientConfig201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a referral recipient config
     */
    async updateReferralRecipientConfig(requestParameters: UpdateReferralRecipientConfigOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateReferralRecipientConfig201Response> {
        const response = await this.updateReferralRecipientConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update referral status
     */
    async updateReferralStatusRaw(requestParameters: UpdateReferralStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.referralId === null || requestParameters.referralId === undefined) {
            throw new runtime.RequiredError('referralId','Required parameter requestParameters.referralId was null or undefined when calling updateReferralStatus.');
        }

        if (requestParameters.updateReferralStatusRequest === null || requestParameters.updateReferralStatusRequest === undefined) {
            throw new runtime.RequiredError('updateReferralStatusRequest','Required parameter requestParameters.updateReferralStatusRequest was null or undefined when calling updateReferralStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/referrals/{referral_id}/status`.replace(`{${"referral_id"}}`, encodeURIComponent(String(requestParameters.referralId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReferralStatusRequestToJSON(requestParameters.updateReferralStatusRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update referral status
     */
    async updateReferralStatus(requestParameters: UpdateReferralStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateReferralStatusRaw(requestParameters, initOverrides);
    }

    /**
     * Update a screener admission flag
     */
    async updateScreenerAdmissionFlagRaw(requestParameters: UpdateScreenerAdmissionFlagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateScreenerAdmissionFlag201Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateScreenerAdmissionFlag.');
        }

        if (requestParameters.findAllScreenerAdmissionFlags200ResponseDataInner === null || requestParameters.findAllScreenerAdmissionFlags200ResponseDataInner === undefined) {
            throw new runtime.RequiredError('findAllScreenerAdmissionFlags200ResponseDataInner','Required parameter requestParameters.findAllScreenerAdmissionFlags200ResponseDataInner was null or undefined when calling updateScreenerAdmissionFlag.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/screener-admission-flags/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FindAllScreenerAdmissionFlags200ResponseDataInnerToJSON(requestParameters.findAllScreenerAdmissionFlags200ResponseDataInner),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateScreenerAdmissionFlag201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a screener admission flag
     */
    async updateScreenerAdmissionFlag(requestParameters: UpdateScreenerAdmissionFlagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateScreenerAdmissionFlag201Response> {
        const response = await this.updateScreenerAdmissionFlagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the rank of a screener bed unit
     * Update screener bed unit rank
     */
    async updateScreenerBedUnitRankRaw(requestParameters: UpdateScreenerBedUnitRankOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllScreenerBedUnits200Response>> {
        if (requestParameters.bedUnitId === null || requestParameters.bedUnitId === undefined) {
            throw new runtime.RequiredError('bedUnitId','Required parameter requestParameters.bedUnitId was null or undefined when calling updateScreenerBedUnitRank.');
        }

        if (requestParameters.updateScreenerBedUnitRankRequest === null || requestParameters.updateScreenerBedUnitRankRequest === undefined) {
            throw new runtime.RequiredError('updateScreenerBedUnitRankRequest','Required parameter requestParameters.updateScreenerBedUnitRankRequest was null or undefined when calling updateScreenerBedUnitRank.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/screener-bed-units/{bed_unit_id}/rank`.replace(`{${"bed_unit_id"}}`, encodeURIComponent(String(requestParameters.bedUnitId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateScreenerBedUnitRankRequestToJSON(requestParameters.updateScreenerBedUnitRankRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllScreenerBedUnits200ResponseFromJSON(jsonValue));
    }

    /**
     * Update the rank of a screener bed unit
     * Update screener bed unit rank
     */
    async updateScreenerBedUnitRank(requestParameters: UpdateScreenerBedUnitRankOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllScreenerBedUnits200Response> {
        const response = await this.updateScreenerBedUnitRankRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a screener lead admission flag
     */
    async updateScreenerLeadAdmissionFlagRaw(requestParameters: UpdateScreenerLeadAdmissionFlagOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateScreenerLeadAdmissionFlag200Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateScreenerLeadAdmissionFlag.');
        }

        if (requestParameters.updateScreenerLeadAdmissionFlagRequest === null || requestParameters.updateScreenerLeadAdmissionFlagRequest === undefined) {
            throw new runtime.RequiredError('updateScreenerLeadAdmissionFlagRequest','Required parameter requestParameters.updateScreenerLeadAdmissionFlagRequest was null or undefined when calling updateScreenerLeadAdmissionFlag.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/screener-lead-admission-flags/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateScreenerLeadAdmissionFlagRequestToJSON(requestParameters.updateScreenerLeadAdmissionFlagRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateScreenerLeadAdmissionFlag200ResponseFromJSON(jsonValue));
    }

    /**
     * Update a screener lead admission flag
     */
    async updateScreenerLeadAdmissionFlag(requestParameters: UpdateScreenerLeadAdmissionFlagOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateScreenerLeadAdmissionFlag200Response> {
        const response = await this.updateScreenerLeadAdmissionFlagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a screener setting for an organization
     * Update a screener setting
     */
    async updateScreenerSettingRaw(requestParameters: UpdateScreenerSettingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.settingName === null || requestParameters.settingName === undefined) {
            throw new runtime.RequiredError('settingName','Required parameter requestParameters.settingName was null or undefined when calling updateScreenerSetting.');
        }

        if (requestParameters.updateScreenerSettingRequest === null || requestParameters.updateScreenerSettingRequest === undefined) {
            throw new runtime.RequiredError('updateScreenerSettingRequest','Required parameter requestParameters.updateScreenerSettingRequest was null or undefined when calling updateScreenerSetting.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/screener-settings/{setting_name}`.replace(`{${"setting_name"}}`, encodeURIComponent(String(requestParameters.settingName))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateScreenerSettingRequestToJSON(requestParameters.updateScreenerSettingRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a screener setting for an organization
     * Update a screener setting
     */
    async updateScreenerSetting(requestParameters: UpdateScreenerSettingOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateScreenerSettingRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const CheckEligibilityActionEnum = {
    UpdateMoveInDate: 'update-move-in-date',
    UpdateHospitalizedDate: 'update-hospitalized-date',
    UpdateLoaDate: 'update-loa-date',
    RevertMovedOut: 'revert-moved-out',
    RevertBedSwap: 'revert-bed-swap',
    RevertBedChange: 'revert-bed-change',
    RevertLoa: 'revert-loa'
} as const;
export type CheckEligibilityActionEnum = typeof CheckEligibilityActionEnum[keyof typeof CheckEligibilityActionEnum];
/**
 * @export
 */
export const FindAllCriteriaTargetsCriteriaTypeEnum = {
    Rule: 'rule',
    MedRule: 'med_rule',
    DataPull: 'data_pull'
} as const;
export type FindAllCriteriaTargetsCriteriaTypeEnum = typeof FindAllCriteriaTargetsCriteriaTypeEnum[keyof typeof FindAllCriteriaTargetsCriteriaTypeEnum];
/**
 * @export
 */
export const FindAllFaxesFacilityTypeEnum = {
    SkilledNursing: 'SKILLED_NURSING',
    CriticalCare: 'CRITICAL_CARE',
    HomeHealth: 'HOME_HEALTH',
    AssistedLiving: 'ASSISTED_LIVING',
    LongTermCareHospital: 'LONG_TERM_CARE_HOSPITAL',
    Hospice: 'HOSPICE',
    DialysisCenter: 'DIALYSIS_CENTER'
} as const;
export type FindAllFaxesFacilityTypeEnum = typeof FindAllFaxesFacilityTypeEnum[keyof typeof FindAllFaxesFacilityTypeEnum];
/**
 * @export
 */
export const FindAllIntegrationEventsByFacilityIdFilterEnum = {
    All: 'all',
    Active: 'active',
    Applied: 'applied',
    Notifications: 'notifications',
    Review: 'review',
    Dismissed: 'dismissed'
} as const;
export type FindAllIntegrationEventsByFacilityIdFilterEnum = typeof FindAllIntegrationEventsByFacilityIdFilterEnum[keyof typeof FindAllIntegrationEventsByFacilityIdFilterEnum];
/**
 * @export
 */
export const GetAllowedRecipientsReferralTypeEnum = {
    Dialysis: 'dialysis',
    HomeHealth: 'home_health',
    Hospice: 'hospice',
    Snf: 'snf',
    Ltac: 'ltac',
    Dme: 'dme',
    Other: 'other'
} as const;
export type GetAllowedRecipientsReferralTypeEnum = typeof GetAllowedRecipientsReferralTypeEnum[keyof typeof GetAllowedRecipientsReferralTypeEnum];
/**
 * @export
 */
export const GetUnreadFaxCountFacilityTypeEnum = {
    SkilledNursing: 'SKILLED_NURSING',
    CriticalCare: 'CRITICAL_CARE',
    HomeHealth: 'HOME_HEALTH',
    AssistedLiving: 'ASSISTED_LIVING',
    LongTermCareHospital: 'LONG_TERM_CARE_HOSPITAL',
    Hospice: 'HOSPICE',
    DialysisCenter: 'DIALYSIS_CENTER'
} as const;
export type GetUnreadFaxCountFacilityTypeEnum = typeof GetUnreadFaxCountFacilityTypeEnum[keyof typeof GetUnreadFaxCountFacilityTypeEnum];
/**
 * @export
 */
export const ProcessIntegrationEventActionEnum = {
    Dismiss: 'dismiss',
    Apply: 'apply',
    MarkAsApplied: 'mark_as_applied'
} as const;
export type ProcessIntegrationEventActionEnum = typeof ProcessIntegrationEventActionEnum[keyof typeof ProcessIntegrationEventActionEnum];
